/* ════════════════════════════════════════════════════════════════
   DADOS DA SECÇÃO DE SALDOS / LIQUIDAÇÃO
   ----------------------------------------------------------------
   GERADO AUTOMATICAMENTE a partir de saldos_items.json (231 artigos).
   NÃO editar à mão em bloco — para regenerar, correr o script de
   geração sobre o JSON. Edições pontuais (descrição, atributos) são
   permitidas campo a campo.

   IMAGENS: cada artigo aponta para /fotos/saldos/<CODIGO>.jpg.
   Enquanto esse ficheiro não existir, aparece o placeholder
   (SALDOS_PLACEHOLDER). Para pôr a foto real de um artigo, basta
   colocar o ficheiro <CODIGO>.jpg em public/fotos/saldos/ — SEM tocar
   neste ficheiro. Ver public/fotos/saldos/README.md.

   Marcas PREMIUM (Chopard, Tom Ford, Prada, Fendi, D&G, Swarovski,
   Tag Heuer, Jil Sander, Victoria Beckham, Carolina Herrera, Missoni,
   Moschino, Maxmara, Gianfranco Ferré, John Richmond, Escada) NÃO
   fazem parte desta secção pública e não devem ser adicionadas aqui.
   ════════════════════════════════════════════════════════════════ */

export const SALDOS_PLACEHOLDER = "/fotos/saldos/_placeholder.svg";

export const SALDOS = [
  {
    id: 20000,
    codigo: "AR16344",
    slug: "adidas-ar16344",
    name: "ADIDAS AF20/00.605856-16 150",
    brand: "Adidas",
    category: "Aros",
    price: 109,
    originalPrice: 218,
    discountPct: 50,
    badge: "Saldos",
    isSaldo: true,
    image: "/fotos/saldos/AR16344.jpg",
    gender: "",
    color: "",
    material: "",
    shape: "",
    style: "",
    faceShape: [],
    description:
      "[TEXTO A REVER] Artigo de saldos da Óptica 13. Descrição detalhada em preparação — contacte-nos ou visite a loja para mais informações sobre este modelo.",
  },
  {
    id: 20001,
    codigo: "AR19163",
    slug: "adidas-ar19163",
    name: "ADIDAS OR5016 002 54/17",
    brand: "Adidas",
    category: "Aros",
    price: 65,
    originalPrice: 130,
    discountPct: 50,
    badge: "Saldos",
    isSaldo: true,
    image: "/fotos/saldos/AR19163.jpg",
    gender: "",
    color: "",
    material: "",
    shape: "",
    style: "",
    faceShape: [],
    description:
      "[TEXTO A REVER] Artigo de saldos da Óptica 13. Descrição detalhada em preparação — contacte-nos ou visite a loja para mais informações sobre este modelo.",
  },
  {
    id: 20002,
    codigo: "AR19164",
    slug: "adidas-ar19164",
    name: "ADIDAS OR5016 054 54/17",
    brand: "Adidas",
    category: "Aros",
    price: 65,
    originalPrice: 130,
    discountPct: 50,
    badge: "Saldos",
    isSaldo: true,
    image: "/fotos/saldos/AR19164.jpg",
    gender: "",
    color: "",
    material: "",
    shape: "",
    style: "",
    faceShape: [],
    description:
      "[TEXTO A REVER] Artigo de saldos da Óptica 13. Descrição detalhada em preparação — contacte-nos ou visite a loja para mais informações sobre este modelo.",
  },
  {
    id: 20003,
    codigo: "AR19165",
    slug: "adidas-ar19165",
    name: "ADIDAS OR5021 001 56/16",
    brand: "Adidas",
    category: "Aros",
    price: 70,
    originalPrice: 139,
    discountPct: 50,
    badge: "Saldos",
    isSaldo: true,
    image: "/fotos/saldos/AR19165.jpg",
    gender: "",
    color: "",
    material: "",
    shape: "",
    style: "",
    faceShape: [],
    description:
      "[TEXTO A REVER] Artigo de saldos da Óptica 13. Descrição detalhada em preparação — contacte-nos ou visite a loja para mais informações sobre este modelo.",
  },
  {
    id: 20004,
    codigo: "OS13900",
    slug: "adidas-os13900",
    name: "ADIDAS OR0044 01A",
    brand: "Adidas",
    category: "Óculos de Sol",
    price: 70,
    originalPrice: 140,
    discountPct: 50,
    badge: "Saldos",
    isSaldo: true,
    image: "/fotos/saldos/OS13900.jpg",
    gender: "",
    color: "",
    material: "",
    shape: "",
    style: "",
    faceShape: [],
    description:
      "[TEXTO A REVER] Artigo de saldos da Óptica 13. Descrição detalhada em preparação — contacte-nos ou visite a loja para mais informações sobre este modelo.",
  },
  {
    id: 20005,
    codigo: "AR19923",
    slug: "ana-hickmann-ar19923",
    name: "ANA HICKMANN E01 E01",
    brand: "Ana Hickmann",
    category: "Aros",
    price: 79,
    originalPrice: 157,
    discountPct: 50,
    badge: "Saldos",
    isSaldo: true,
    image: "/fotos/saldos/AR19923.jpg",
    gender: "",
    color: "",
    material: "",
    shape: "",
    style: "",
    faceShape: [],
    description:
      "[TEXTO A REVER] Artigo de saldos da Óptica 13. Descrição detalhada em preparação — contacte-nos ou visite a loja para mais informações sobre este modelo.",
  },
  {
    id: 20006,
    codigo: "AR19924",
    slug: "ana-hickmann-ar19924",
    name: "ANA HICKMANN H04 H04",
    brand: "Ana Hickmann",
    category: "Aros",
    price: 74,
    originalPrice: 148,
    discountPct: 50,
    badge: "Saldos",
    isSaldo: true,
    image: "/fotos/saldos/AR19924.jpg",
    gender: "",
    color: "",
    material: "",
    shape: "",
    style: "",
    faceShape: [],
    description:
      "[TEXTO A REVER] Artigo de saldos da Óptica 13. Descrição detalhada em preparação — contacte-nos ou visite a loja para mais informações sobre este modelo.",
  },
  {
    id: 20007,
    codigo: "AR19563",
    slug: "calvin-klein-ar19563",
    name: "CALVIN KLEIN CK20507 028 52/18",
    brand: "Calvin Klein",
    category: "Aros",
    price: 108,
    originalPrice: 215,
    discountPct: 50,
    badge: "Saldos",
    isSaldo: true,
    image: "/fotos/saldos/AR19563.jpg",
    gender: "",
    color: "",
    material: "",
    shape: "",
    style: "",
    faceShape: [],
    description:
      "[TEXTO A REVER] Artigo de saldos da Óptica 13. Descrição detalhada em preparação — contacte-nos ou visite a loja para mais informações sobre este modelo.",
  },
  {
    id: 20008,
    codigo: "OS12820",
    slug: "carrera-os12820",
    name: "CARRERA 5035/S.RG0X2",
    brand: "Carrera",
    category: "Óculos de Sol",
    price: 65,
    originalPrice: 129,
    discountPct: 50,
    badge: "Saldos",
    isSaldo: true,
    image: "/fotos/saldos/OS12820.jpg",
    gender: "",
    color: "",
    material: "",
    shape: "",
    style: "",
    faceShape: [],
    description:
      "[TEXTO A REVER] Artigo de saldos da Óptica 13. Descrição detalhada em preparação — contacte-nos ou visite a loja para mais informações sobre este modelo.",
  },
  {
    id: 20009,
    codigo: "OS12904",
    slug: "carrera-os12904",
    name: "CARRERA 115/S.1PWHD",
    brand: "Carrera",
    category: "Óculos de Sol",
    price: 77,
    originalPrice: 154,
    discountPct: 50,
    badge: "Saldos",
    isSaldo: true,
    image: "/fotos/saldos/OS12904.jpg",
    gender: "",
    color: "",
    material: "",
    shape: "",
    style: "",
    faceShape: [],
    description:
      "[TEXTO A REVER] Artigo de saldos da Óptica 13. Descrição detalhada em preparação — contacte-nos ou visite a loja para mais informações sobre este modelo.",
  },
  {
    id: 20010,
    codigo: "OS12906",
    slug: "carrera-os12906",
    name: "CARRERA 6008.TJGKU",
    brand: "Carrera",
    category: "Óculos de Sol",
    price: 77,
    originalPrice: 154,
    discountPct: 50,
    badge: "Saldos",
    isSaldo: true,
    image: "/fotos/saldos/OS12906.jpg",
    gender: "",
    color: "",
    material: "",
    shape: "",
    style: "",
    faceShape: [],
    description:
      "[TEXTO A REVER] Artigo de saldos da Óptica 13. Descrição detalhada em preparação — contacte-nos ou visite a loja para mais informações sobre este modelo.",
  },
  {
    id: 20011,
    codigo: "AR18029",
    slug: "chloe-ar18029",
    name: "CHLOE CE2147 705",
    brand: "Chloe",
    category: "Aros",
    price: 137,
    originalPrice: 273,
    discountPct: 50,
    badge: "Saldos",
    isSaldo: true,
    image: "/fotos/saldos/AR18029.jpg",
    gender: "",
    color: "",
    material: "",
    shape: "",
    style: "",
    faceShape: [],
    description:
      "[TEXTO A REVER] Artigo de saldos da Óptica 13. Descrição detalhada em preparação — contacte-nos ou visite a loja para mais informações sobre este modelo.",
  },
  {
    id: 20012,
    codigo: "OS13668",
    slug: "chloe-os13668",
    name: "CHLOE CE142S 817",
    brand: "Chloe",
    category: "Óculos de Sol",
    price: 195,
    originalPrice: 390,
    discountPct: 50,
    badge: "Saldos",
    isSaldo: true,
    image: "/fotos/saldos/OS13668.jpg",
    gender: "",
    color: "",
    material: "",
    shape: "",
    style: "",
    faceShape: [],
    description:
      "[TEXTO A REVER] Artigo de saldos da Óptica 13. Descrição detalhada em preparação — contacte-nos ou visite a loja para mais informações sobre este modelo.",
  },
  {
    id: 20013,
    codigo: "AR15608",
    slug: "cierzo-ar15608",
    name: "CIERZO A3026.1",
    brand: "Cierzo",
    category: "Aros",
    price: 60,
    originalPrice: 119,
    discountPct: 50,
    badge: "Saldos",
    isSaldo: true,
    image: "/fotos/saldos/AR15608.jpg",
    gender: "",
    color: "",
    material: "",
    shape: "",
    style: "",
    faceShape: [],
    description:
      "[TEXTO A REVER] Artigo de saldos da Óptica 13. Descrição detalhada em preparação — contacte-nos ou visite a loja para mais informações sobre este modelo.",
  },
  {
    id: 20014,
    codigo: "AR18349",
    slug: "cierzo-ar18349",
    name: "CIERZO CA3045 02",
    brand: "Cierzo",
    category: "Aros",
    price: 60,
    originalPrice: 119,
    discountPct: 50,
    badge: "Saldos",
    isSaldo: true,
    image: "/fotos/saldos/AR18349.jpg",
    gender: "",
    color: "",
    material: "",
    shape: "",
    style: "",
    faceShape: [],
    description:
      "[TEXTO A REVER] Artigo de saldos da Óptica 13. Descrição detalhada em preparação — contacte-nos ou visite a loja para mais informações sobre este modelo.",
  },
  {
    id: 20015,
    codigo: "AR18818",
    slug: "cierzo-ar18818",
    name: "CIERZO M1037 C2 52/22",
    brand: "Cierzo",
    category: "Aros",
    price: 60,
    originalPrice: 119,
    discountPct: 50,
    badge: "Saldos",
    isSaldo: true,
    image: "/fotos/saldos/AR18818.jpg",
    gender: "",
    color: "",
    material: "",
    shape: "",
    style: "",
    faceShape: [],
    description:
      "[TEXTO A REVER] Artigo de saldos da Óptica 13. Descrição detalhada em preparação — contacte-nos ou visite a loja para mais informações sobre este modelo.",
  },
  {
    id: 20016,
    codigo: "AR18819",
    slug: "cierzo-ar18819",
    name: "CIERZO M1037 C1 52/22",
    brand: "Cierzo",
    category: "Aros",
    price: 60,
    originalPrice: 119,
    discountPct: 50,
    badge: "Saldos",
    isSaldo: true,
    image: "/fotos/saldos/AR18819.jpg",
    gender: "",
    color: "",
    material: "",
    shape: "",
    style: "",
    faceShape: [],
    description:
      "[TEXTO A REVER] Artigo de saldos da Óptica 13. Descrição detalhada em preparação — contacte-nos ou visite a loja para mais informações sobre este modelo.",
  },
  {
    id: 20017,
    codigo: "AR19102",
    slug: "cierzo-ar19102",
    name: "CIERZO A4012 C2 48/16",
    brand: "Cierzo",
    category: "Aros",
    price: 60,
    originalPrice: 119,
    discountPct: 50,
    badge: "Saldos",
    isSaldo: true,
    image: "/fotos/saldos/AR19102.jpg",
    gender: "",
    color: "",
    material: "",
    shape: "",
    style: "",
    faceShape: [],
    description:
      "[TEXTO A REVER] Artigo de saldos da Óptica 13. Descrição detalhada em preparação — contacte-nos ou visite a loja para mais informações sobre este modelo.",
  },
  {
    id: 20018,
    codigo: "AR19601",
    slug: "cierzo-ar19601",
    name: "CIERZO A1042 C1 54/16",
    brand: "Cierzo",
    category: "Aros",
    price: 60,
    originalPrice: 119,
    discountPct: 50,
    badge: "Saldos",
    isSaldo: true,
    image: "/fotos/saldos/AR19601.jpg",
    gender: "",
    color: "",
    material: "",
    shape: "",
    style: "",
    faceShape: [],
    description:
      "[TEXTO A REVER] Artigo de saldos da Óptica 13. Descrição detalhada em preparação — contacte-nos ou visite a loja para mais informações sobre este modelo.",
  },
  {
    id: 20019,
    codigo: "AR19603",
    slug: "cierzo-ar19603",
    name: "CIERZO A1042 C3 54/16",
    brand: "Cierzo",
    category: "Aros",
    price: 60,
    originalPrice: 119,
    discountPct: 50,
    badge: "Saldos",
    isSaldo: true,
    image: "/fotos/saldos/AR19603.jpg",
    gender: "",
    color: "",
    material: "",
    shape: "",
    style: "",
    faceShape: [],
    description:
      "[TEXTO A REVER] Artigo de saldos da Óptica 13. Descrição detalhada em preparação — contacte-nos ou visite a loja para mais informações sobre este modelo.",
  },
  {
    id: 20020,
    codigo: "AR19605",
    slug: "cierzo-ar19605",
    name: "CIERZO M1038 C2 50/21",
    brand: "Cierzo",
    category: "Aros",
    price: 60,
    originalPrice: 119,
    discountPct: 50,
    badge: "Saldos",
    isSaldo: true,
    image: "/fotos/saldos/AR19605.jpg",
    gender: "",
    color: "",
    material: "",
    shape: "",
    style: "",
    faceShape: [],
    description:
      "[TEXTO A REVER] Artigo de saldos da Óptica 13. Descrição detalhada em preparação — contacte-nos ou visite a loja para mais informações sobre este modelo.",
  },
  {
    id: 20021,
    codigo: "AR19611",
    slug: "cierzo-ar19611",
    name: "CIERZO A2059 C1 53/17",
    brand: "Cierzo",
    category: "Aros",
    price: 60,
    originalPrice: 119,
    discountPct: 50,
    badge: "Saldos",
    isSaldo: true,
    image: "/fotos/saldos/AR19611.jpg",
    gender: "",
    color: "",
    material: "",
    shape: "",
    style: "",
    faceShape: [],
    description:
      "[TEXTO A REVER] Artigo de saldos da Óptica 13. Descrição detalhada em preparação — contacte-nos ou visite a loja para mais informações sobre este modelo.",
  },
  {
    id: 20022,
    codigo: "AR19612",
    slug: "cierzo-ar19612",
    name: "CIERZO A2059 C2 53/17",
    brand: "Cierzo",
    category: "Aros",
    price: 60,
    originalPrice: 119,
    discountPct: 50,
    badge: "Saldos",
    isSaldo: true,
    image: "/fotos/saldos/AR19612.jpg",
    gender: "",
    color: "",
    material: "",
    shape: "",
    style: "",
    faceShape: [],
    description:
      "[TEXTO A REVER] Artigo de saldos da Óptica 13. Descrição detalhada em preparação — contacte-nos ou visite a loja para mais informações sobre este modelo.",
  },
  {
    id: 20023,
    codigo: "AR19614",
    slug: "cierzo-ar19614",
    name: "CIERZO A2060 C2 53/17",
    brand: "Cierzo",
    category: "Aros",
    price: 60,
    originalPrice: 119,
    discountPct: 50,
    badge: "Saldos",
    isSaldo: true,
    image: "/fotos/saldos/AR19614.jpg",
    gender: "",
    color: "",
    material: "",
    shape: "",
    style: "",
    faceShape: [],
    description:
      "[TEXTO A REVER] Artigo de saldos da Óptica 13. Descrição detalhada em preparação — contacte-nos ou visite a loja para mais informações sobre este modelo.",
  },
  {
    id: 20024,
    codigo: "AR19617",
    slug: "cierzo-ar19617",
    name: "CIERZO M2049 C2 54/16",
    brand: "Cierzo",
    category: "Aros",
    price: 60,
    originalPrice: 119,
    discountPct: 50,
    badge: "Saldos",
    isSaldo: true,
    image: "/fotos/saldos/AR19617.jpg",
    gender: "",
    color: "",
    material: "",
    shape: "",
    style: "",
    faceShape: [],
    description:
      "[TEXTO A REVER] Artigo de saldos da Óptica 13. Descrição detalhada em preparação — contacte-nos ou visite a loja para mais informações sobre este modelo.",
  },
  {
    id: 20025,
    codigo: "AR19933",
    slug: "cierzo-ar19933",
    name: "CIERZO A4013 C1",
    brand: "Cierzo",
    category: "Aros",
    price: 60,
    originalPrice: 119,
    discountPct: 50,
    badge: "Saldos",
    isSaldo: true,
    image: "/fotos/saldos/AR19933.jpg",
    gender: "",
    color: "",
    material: "",
    shape: "",
    style: "",
    faceShape: [],
    description:
      "[TEXTO A REVER] Artigo de saldos da Óptica 13. Descrição detalhada em preparação — contacte-nos ou visite a loja para mais informações sobre este modelo.",
  },
  {
    id: 20026,
    codigo: "AR19937",
    slug: "cierzo-ar19937",
    name: "CIERZO A4014 C2",
    brand: "Cierzo",
    category: "Aros",
    price: 60,
    originalPrice: 119,
    discountPct: 50,
    badge: "Saldos",
    isSaldo: true,
    image: "/fotos/saldos/AR19937.jpg",
    gender: "",
    color: "",
    material: "",
    shape: "",
    style: "",
    faceShape: [],
    description:
      "[TEXTO A REVER] Artigo de saldos da Óptica 13. Descrição detalhada em preparação — contacte-nos ou visite a loja para mais informações sobre este modelo.",
  },
  {
    id: 20027,
    codigo: "AR19946",
    slug: "cierzo-ar19946",
    name: "CIERZO M1040 C2",
    brand: "Cierzo",
    category: "Aros",
    price: 60,
    originalPrice: 119,
    discountPct: 50,
    badge: "Saldos",
    isSaldo: true,
    image: "/fotos/saldos/AR19946.jpg",
    gender: "",
    color: "",
    material: "",
    shape: "",
    style: "",
    faceShape: [],
    description:
      "[TEXTO A REVER] Artigo de saldos da Óptica 13. Descrição detalhada em preparação — contacte-nos ou visite a loja para mais informações sobre este modelo.",
  },
  {
    id: 20028,
    codigo: "AR19954",
    slug: "cierzo-ar19954",
    name: "CIERZO M2049 C1",
    brand: "Cierzo",
    category: "Aros",
    price: 60,
    originalPrice: 119,
    discountPct: 50,
    badge: "Saldos",
    isSaldo: true,
    image: "/fotos/saldos/AR19954.jpg",
    gender: "",
    color: "",
    material: "",
    shape: "",
    style: "",
    faceShape: [],
    description:
      "[TEXTO A REVER] Artigo de saldos da Óptica 13. Descrição detalhada em preparação — contacte-nos ou visite a loja para mais informações sobre este modelo.",
  },
  {
    id: 20029,
    codigo: "AR19955",
    slug: "cierzo-ar19955",
    name: "CIERZO M2049 C3",
    brand: "Cierzo",
    category: "Aros",
    price: 60,
    originalPrice: 119,
    discountPct: 50,
    badge: "Saldos",
    isSaldo: true,
    image: "/fotos/saldos/AR19955.jpg",
    gender: "",
    color: "",
    material: "",
    shape: "",
    style: "",
    faceShape: [],
    description:
      "[TEXTO A REVER] Artigo de saldos da Óptica 13. Descrição detalhada em preparação — contacte-nos ou visite a loja para mais informações sobre este modelo.",
  },
  {
    id: 20030,
    codigo: "AR19957",
    slug: "cierzo-ar19957",
    name: "CIERZO A2062 C3",
    brand: "Cierzo",
    category: "Aros",
    price: 60,
    originalPrice: 119,
    discountPct: 50,
    badge: "Saldos",
    isSaldo: true,
    image: "/fotos/saldos/AR19957.jpg",
    gender: "",
    color: "",
    material: "",
    shape: "",
    style: "",
    faceShape: [],
    description:
      "[TEXTO A REVER] Artigo de saldos da Óptica 13. Descrição detalhada em preparação — contacte-nos ou visite a loja para mais informações sobre este modelo.",
  },
  {
    id: 20031,
    codigo: "AR19960",
    slug: "cierzo-ar19960",
    name: "CIERZO M2051 C1",
    brand: "Cierzo",
    category: "Aros",
    price: 60,
    originalPrice: 119,
    discountPct: 50,
    badge: "Saldos",
    isSaldo: true,
    image: "/fotos/saldos/AR19960.jpg",
    gender: "",
    color: "",
    material: "",
    shape: "",
    style: "",
    faceShape: [],
    description:
      "[TEXTO A REVER] Artigo de saldos da Óptica 13. Descrição detalhada em preparação — contacte-nos ou visite a loja para mais informações sobre este modelo.",
  },
  {
    id: 20032,
    codigo: "AR19967",
    slug: "cierzo-ar19967",
    name: "CIERZO M2052 C3",
    brand: "Cierzo",
    category: "Aros",
    price: 60,
    originalPrice: 119,
    discountPct: 50,
    badge: "Saldos",
    isSaldo: true,
    image: "/fotos/saldos/AR19967.jpg",
    gender: "",
    color: "",
    material: "",
    shape: "",
    style: "",
    faceShape: [],
    description:
      "[TEXTO A REVER] Artigo de saldos da Óptica 13. Descrição detalhada em preparação — contacte-nos ou visite a loja para mais informações sobre este modelo.",
  },
  {
    id: 20033,
    codigo: "OS11818",
    slug: "cierzo-os11818",
    name: "CIERZO A53004.2",
    brand: "Cierzo",
    category: "Óculos de Sol",
    price: 60,
    originalPrice: 119,
    discountPct: 50,
    badge: "Saldos",
    isSaldo: true,
    image: "/fotos/saldos/OS11818.jpg",
    gender: "",
    color: "",
    material: "",
    shape: "",
    style: "",
    faceShape: [],
    description:
      "[TEXTO A REVER] Artigo de saldos da Óptica 13. Descrição detalhada em preparação — contacte-nos ou visite a loja para mais informações sobre este modelo.",
  },
  {
    id: 20034,
    codigo: "OS13481",
    slug: "cierzo-os13481",
    name: "CIERZO A51017 C1",
    brand: "Cierzo",
    category: "Óculos de Sol",
    price: 60,
    originalPrice: 119,
    discountPct: 50,
    badge: "Saldos",
    isSaldo: true,
    image: "/fotos/saldos/OS13481.jpg",
    gender: "",
    color: "",
    material: "",
    shape: "",
    style: "",
    faceShape: [],
    description:
      "[TEXTO A REVER] Artigo de saldos da Óptica 13. Descrição detalhada em preparação — contacte-nos ou visite a loja para mais informações sobre este modelo.",
  },
  {
    id: 20035,
    codigo: "OS13482",
    slug: "cierzo-os13482",
    name: "CIERZO A51017 C2",
    brand: "Cierzo",
    category: "Óculos de Sol",
    price: 60,
    originalPrice: 119,
    discountPct: 50,
    badge: "Saldos",
    isSaldo: true,
    image: "/fotos/saldos/OS13482.jpg",
    gender: "",
    color: "",
    material: "",
    shape: "",
    style: "",
    faceShape: [],
    description:
      "[TEXTO A REVER] Artigo de saldos da Óptica 13. Descrição detalhada em preparação — contacte-nos ou visite a loja para mais informações sobre este modelo.",
  },
  {
    id: 20036,
    codigo: "OS13656",
    slug: "cierzo-os13656",
    name: "CIERZO CA51018 03",
    brand: "Cierzo",
    category: "Óculos de Sol",
    price: 60,
    originalPrice: 119,
    discountPct: 50,
    badge: "Saldos",
    isSaldo: true,
    image: "/fotos/saldos/OS13656.jpg",
    gender: "",
    color: "",
    material: "",
    shape: "",
    style: "",
    faceShape: [],
    description:
      "[TEXTO A REVER] Artigo de saldos da Óptica 13. Descrição detalhada em preparação — contacte-nos ou visite a loja para mais informações sobre este modelo.",
  },
  {
    id: 20037,
    codigo: "OS13686",
    slug: "cierzo-os13686",
    name: "CIERZO A5120 C2 52/21",
    brand: "Cierzo",
    category: "Óculos de Sol",
    price: 60,
    originalPrice: 119,
    discountPct: 50,
    badge: "Saldos",
    isSaldo: true,
    image: "/fotos/saldos/OS13686.jpg",
    gender: "",
    color: "",
    material: "",
    shape: "",
    style: "",
    faceShape: [],
    description:
      "[TEXTO A REVER] Artigo de saldos da Óptica 13. Descrição detalhada em preparação — contacte-nos ou visite a loja para mais informações sobre este modelo.",
  },
  {
    id: 20038,
    codigo: "OS13687",
    slug: "cierzo-os13687",
    name: "CIERZO A51020 C1 52/21",
    brand: "Cierzo",
    category: "Óculos de Sol",
    price: 60,
    originalPrice: 119,
    discountPct: 50,
    badge: "Saldos",
    isSaldo: true,
    image: "/fotos/saldos/OS13687.jpg",
    gender: "",
    color: "",
    material: "",
    shape: "",
    style: "",
    faceShape: [],
    description:
      "[TEXTO A REVER] Artigo de saldos da Óptica 13. Descrição detalhada em preparação — contacte-nos ou visite a loja para mais informações sobre este modelo.",
  },
  {
    id: 20039,
    codigo: "OS13691",
    slug: "cierzo-os13691",
    name: "CIERZO A51021 C2 57/16",
    brand: "Cierzo",
    category: "Óculos de Sol",
    price: 60,
    originalPrice: 119,
    discountPct: 50,
    badge: "Saldos",
    isSaldo: true,
    image: "/fotos/saldos/OS13691.jpg",
    gender: "",
    color: "",
    material: "",
    shape: "",
    style: "",
    faceShape: [],
    description:
      "[TEXTO A REVER] Artigo de saldos da Óptica 13. Descrição detalhada em preparação — contacte-nos ou visite a loja para mais informações sobre este modelo.",
  },
  {
    id: 20040,
    codigo: "OS13788",
    slug: "cierzo-os13788",
    name: "CIERZO 52025",
    brand: "Cierzo",
    category: "Óculos de Sol",
    price: 60,
    originalPrice: 119,
    discountPct: 50,
    badge: "Saldos",
    isSaldo: true,
    image: "/fotos/saldos/OS13788.jpg",
    gender: "",
    color: "",
    material: "",
    shape: "",
    style: "",
    faceShape: [],
    description:
      "[TEXTO A REVER] Artigo de saldos da Óptica 13. Descrição detalhada em preparação — contacte-nos ou visite a loja para mais informações sobre este modelo.",
  },
  {
    id: 20041,
    codigo: "AR17098",
    slug: "estygma-ar17098",
    name: "ESTYGMA M2013.C01",
    brand: "Estygma",
    category: "Aros",
    price: 50,
    originalPrice: 99,
    discountPct: 50,
    badge: "Saldos",
    isSaldo: true,
    image: "/fotos/saldos/AR17098.jpg",
    gender: "",
    color: "",
    material: "",
    shape: "",
    style: "",
    faceShape: [],
    description:
      "[TEXTO A REVER] Artigo de saldos da Óptica 13. Descrição detalhada em preparação — contacte-nos ou visite a loja para mais informações sobre este modelo.",
  },
  {
    id: 20042,
    codigo: "AR17686",
    slug: "estygma-ar17686",
    name: "ESTYGMA M1011 C2",
    brand: "Estygma",
    category: "Aros",
    price: 50,
    originalPrice: 99,
    discountPct: 50,
    badge: "Saldos",
    isSaldo: true,
    image: "/fotos/saldos/AR17686.jpg",
    gender: "",
    color: "",
    material: "",
    shape: "",
    style: "",
    faceShape: [],
    description:
      "[TEXTO A REVER] Artigo de saldos da Óptica 13. Descrição detalhada em preparação — contacte-nos ou visite a loja para mais informações sobre este modelo.",
  },
  {
    id: 20043,
    codigo: "AR17701",
    slug: "estygma-ar17701",
    name: "ESTYGMA CN2021 C1",
    brand: "Estygma",
    category: "Aros",
    price: 50,
    originalPrice: 99,
    discountPct: 50,
    badge: "Saldos",
    isSaldo: true,
    image: "/fotos/saldos/AR17701.jpg",
    gender: "",
    color: "",
    material: "",
    shape: "",
    style: "",
    faceShape: [],
    description:
      "[TEXTO A REVER] Artigo de saldos da Óptica 13. Descrição detalhada em preparação — contacte-nos ou visite a loja para mais informações sobre este modelo.",
  },
  {
    id: 20044,
    codigo: "AR18079",
    slug: "estygma-ar18079",
    name: "ESTYGMA N1015 C2",
    brand: "Estygma",
    category: "Aros",
    price: 50,
    originalPrice: 99,
    discountPct: 50,
    badge: "Saldos",
    isSaldo: true,
    image: "/fotos/saldos/AR18079.jpg",
    gender: "",
    color: "",
    material: "",
    shape: "",
    style: "",
    faceShape: [],
    description:
      "[TEXTO A REVER] Artigo de saldos da Óptica 13. Descrição detalhada em preparação — contacte-nos ou visite a loja para mais informações sobre este modelo.",
  },
  {
    id: 20045,
    codigo: "AR18081",
    slug: "estygma-ar18081",
    name: "ESTYGMA M1013 C2",
    brand: "Estygma",
    category: "Aros",
    price: 50,
    originalPrice: 99,
    discountPct: 50,
    badge: "Saldos",
    isSaldo: true,
    image: "/fotos/saldos/AR18081.jpg",
    gender: "",
    color: "",
    material: "",
    shape: "",
    style: "",
    faceShape: [],
    description:
      "[TEXTO A REVER] Artigo de saldos da Óptica 13. Descrição detalhada em preparação — contacte-nos ou visite a loja para mais informações sobre este modelo.",
  },
  {
    id: 20046,
    codigo: "AR18101",
    slug: "estygma-ar18101",
    name: "ESTYGMA G2002 C1",
    brand: "Estygma",
    category: "Aros",
    price: 50,
    originalPrice: 99,
    discountPct: 50,
    badge: "Saldos",
    isSaldo: true,
    image: "/fotos/saldos/AR18101.jpg",
    gender: "",
    color: "",
    material: "",
    shape: "",
    style: "",
    faceShape: [],
    description:
      "[TEXTO A REVER] Artigo de saldos da Óptica 13. Descrição detalhada em preparação — contacte-nos ou visite a loja para mais informações sobre este modelo.",
  },
  {
    id: 20047,
    codigo: "AR18102",
    slug: "estygma-ar18102",
    name: "ESTYGMA G2002 C2",
    brand: "Estygma",
    category: "Aros",
    price: 50,
    originalPrice: 99,
    discountPct: 50,
    badge: "Saldos",
    isSaldo: true,
    image: "/fotos/saldos/AR18102.jpg",
    gender: "",
    color: "",
    material: "",
    shape: "",
    style: "",
    faceShape: [],
    description:
      "[TEXTO A REVER] Artigo de saldos da Óptica 13. Descrição detalhada em preparação — contacte-nos ou visite a loja para mais informações sobre este modelo.",
  },
  {
    id: 20048,
    codigo: "AR18536",
    slug: "estygma-ar18536",
    name: "ESTYGMA M1016 C1 54/18",
    brand: "Estygma",
    category: "Aros",
    price: 50,
    originalPrice: 99,
    discountPct: 50,
    badge: "Saldos",
    isSaldo: true,
    image: "/fotos/saldos/AR18536.jpg",
    gender: "",
    color: "",
    material: "",
    shape: "",
    style: "",
    faceShape: [],
    description:
      "[TEXTO A REVER] Artigo de saldos da Óptica 13. Descrição detalhada em preparação — contacte-nos ou visite a loja para mais informações sobre este modelo.",
  },
  {
    id: 20049,
    codigo: "AR18537",
    slug: "estygma-ar18537",
    name: "ESTYGMA M1016 C2 54/18",
    brand: "Estygma",
    category: "Aros",
    price: 50,
    originalPrice: 99,
    discountPct: 50,
    badge: "Saldos",
    isSaldo: true,
    image: "/fotos/saldos/AR18537.jpg",
    gender: "",
    color: "",
    material: "",
    shape: "",
    style: "",
    faceShape: [],
    description:
      "[TEXTO A REVER] Artigo de saldos da Óptica 13. Descrição detalhada em preparação — contacte-nos ou visite a loja para mais informações sobre este modelo.",
  },
  {
    id: 20050,
    codigo: "AR18542",
    slug: "estygma-ar18542",
    name: "ESTYGMA M1015 C1 55/18",
    brand: "Estygma",
    category: "Aros",
    price: 50,
    originalPrice: 99,
    discountPct: 50,
    badge: "Saldos",
    isSaldo: true,
    image: "/fotos/saldos/AR18542.jpg",
    gender: "",
    color: "",
    material: "",
    shape: "",
    style: "",
    faceShape: [],
    description:
      "[TEXTO A REVER] Artigo de saldos da Óptica 13. Descrição detalhada em preparação — contacte-nos ou visite a loja para mais informações sobre este modelo.",
  },
  {
    id: 20051,
    codigo: "AR18543",
    slug: "estygma-ar18543",
    name: "ESTYGMA M1015 C2 55/18",
    brand: "Estygma",
    category: "Aros",
    price: 50,
    originalPrice: 99,
    discountPct: 50,
    badge: "Saldos",
    isSaldo: true,
    image: "/fotos/saldos/AR18543.jpg",
    gender: "",
    color: "",
    material: "",
    shape: "",
    style: "",
    faceShape: [],
    description:
      "[TEXTO A REVER] Artigo de saldos da Óptica 13. Descrição detalhada em preparação — contacte-nos ou visite a loja para mais informações sobre este modelo.",
  },
  {
    id: 20052,
    codigo: "AR18544",
    slug: "estygma-ar18544",
    name: "ESTYGMA N2022 C1 53/17",
    brand: "Estygma",
    category: "Aros",
    price: 50,
    originalPrice: 99,
    discountPct: 50,
    badge: "Saldos",
    isSaldo: true,
    image: "/fotos/saldos/AR18544.jpg",
    gender: "",
    color: "",
    material: "",
    shape: "",
    style: "",
    faceShape: [],
    description:
      "[TEXTO A REVER] Artigo de saldos da Óptica 13. Descrição detalhada em preparação — contacte-nos ou visite a loja para mais informações sobre este modelo.",
  },
  {
    id: 20053,
    codigo: "AR18545",
    slug: "estygma-ar18545",
    name: "ESTYGMA N2022 C2 53/17",
    brand: "Estygma",
    category: "Aros",
    price: 50,
    originalPrice: 99,
    discountPct: 50,
    badge: "Saldos",
    isSaldo: true,
    image: "/fotos/saldos/AR18545.jpg",
    gender: "",
    color: "",
    material: "",
    shape: "",
    style: "",
    faceShape: [],
    description:
      "[TEXTO A REVER] Artigo de saldos da Óptica 13. Descrição detalhada em preparação — contacte-nos ou visite a loja para mais informações sobre este modelo.",
  },
  {
    id: 20054,
    codigo: "AR18547",
    slug: "estygma-ar18547",
    name: "ESTYGMA N2023 C2 52/16",
    brand: "Estygma",
    category: "Aros",
    price: 50,
    originalPrice: 99,
    discountPct: 50,
    badge: "Saldos",
    isSaldo: true,
    image: "/fotos/saldos/AR18547.jpg",
    gender: "",
    color: "",
    material: "",
    shape: "",
    style: "",
    faceShape: [],
    description:
      "[TEXTO A REVER] Artigo de saldos da Óptica 13. Descrição detalhada em preparação — contacte-nos ou visite a loja para mais informações sobre este modelo.",
  },
  {
    id: 20055,
    codigo: "AR18551",
    slug: "estygma-ar18551",
    name: "ESTYGMA M2023 C2 54/16",
    brand: "Estygma",
    category: "Aros",
    price: 50,
    originalPrice: 99,
    discountPct: 50,
    badge: "Saldos",
    isSaldo: true,
    image: "/fotos/saldos/AR18551.jpg",
    gender: "",
    color: "",
    material: "",
    shape: "",
    style: "",
    faceShape: [],
    description:
      "[TEXTO A REVER] Artigo de saldos da Óptica 13. Descrição detalhada em preparação — contacte-nos ou visite a loja para mais informações sobre este modelo.",
  },
  {
    id: 20056,
    codigo: "AR18554",
    slug: "estygma-ar18554",
    name: "ESTYGMA G1003 C1 54/17",
    brand: "Estygma",
    category: "Aros",
    price: 50,
    originalPrice: 99,
    discountPct: 50,
    badge: "Saldos",
    isSaldo: true,
    image: "/fotos/saldos/AR18554.jpg",
    gender: "",
    color: "",
    material: "",
    shape: "",
    style: "",
    faceShape: [],
    description:
      "[TEXTO A REVER] Artigo de saldos da Óptica 13. Descrição detalhada em preparação — contacte-nos ou visite a loja para mais informações sobre este modelo.",
  },
  {
    id: 20057,
    codigo: "AR19291",
    slug: "estygma-ar19291",
    name: "ESTYGMA ML1017 C2 53/18",
    brand: "Estygma",
    category: "Aros",
    price: 50,
    originalPrice: 99,
    discountPct: 50,
    badge: "Saldos",
    isSaldo: true,
    image: "/fotos/saldos/AR19291.jpg",
    gender: "",
    color: "",
    material: "",
    shape: "",
    style: "",
    faceShape: [],
    description:
      "[TEXTO A REVER] Artigo de saldos da Óptica 13. Descrição detalhada em preparação — contacte-nos ou visite a loja para mais informações sobre este modelo.",
  },
  {
    id: 20058,
    codigo: "AR19292",
    slug: "estygma-ar19292",
    name: "ESTYGMA M2024 C1 53/17",
    brand: "Estygma",
    category: "Aros",
    price: 50,
    originalPrice: 99,
    discountPct: 50,
    badge: "Saldos",
    isSaldo: true,
    image: "/fotos/saldos/AR19292.jpg",
    gender: "",
    color: "",
    material: "",
    shape: "",
    style: "",
    faceShape: [],
    description:
      "[TEXTO A REVER] Artigo de saldos da Óptica 13. Descrição detalhada em preparação — contacte-nos ou visite a loja para mais informações sobre este modelo.",
  },
  {
    id: 20059,
    codigo: "AR19293",
    slug: "estygma-ar19293",
    name: "ESTYGMA M2024 C2 53/17",
    brand: "Estygma",
    category: "Aros",
    price: 50,
    originalPrice: 99,
    discountPct: 50,
    badge: "Saldos",
    isSaldo: true,
    image: "/fotos/saldos/AR19293.jpg",
    gender: "",
    color: "",
    material: "",
    shape: "",
    style: "",
    faceShape: [],
    description:
      "[TEXTO A REVER] Artigo de saldos da Óptica 13. Descrição detalhada em preparação — contacte-nos ou visite a loja para mais informações sobre este modelo.",
  },
  {
    id: 20060,
    codigo: "AR19294",
    slug: "estygma-ar19294",
    name: "ESTYGMA TG1000 C1 54/17",
    brand: "Estygma",
    category: "Aros",
    price: 50,
    originalPrice: 99,
    discountPct: 50,
    badge: "Saldos",
    isSaldo: true,
    image: "/fotos/saldos/AR19294.jpg",
    gender: "",
    color: "",
    material: "",
    shape: "",
    style: "",
    faceShape: [],
    description:
      "[TEXTO A REVER] Artigo de saldos da Óptica 13. Descrição detalhada em preparação — contacte-nos ou visite a loja para mais informações sobre este modelo.",
  },
  {
    id: 20061,
    codigo: "AR19295",
    slug: "estygma-ar19295",
    name: "ESTYGMA TG1000 C2 54/17",
    brand: "Estygma",
    category: "Aros",
    price: 50,
    originalPrice: 99,
    discountPct: 50,
    badge: "Saldos",
    isSaldo: true,
    image: "/fotos/saldos/AR19295.jpg",
    gender: "",
    color: "",
    material: "",
    shape: "",
    style: "",
    faceShape: [],
    description:
      "[TEXTO A REVER] Artigo de saldos da Óptica 13. Descrição detalhada em preparação — contacte-nos ou visite a loja para mais informações sobre este modelo.",
  },
  {
    id: 20062,
    codigo: "AR19296",
    slug: "estygma-ar19296",
    name: "ESTYGMA TG2000 C1 52/17",
    brand: "Estygma",
    category: "Aros",
    price: 50,
    originalPrice: 99,
    discountPct: 50,
    badge: "Saldos",
    isSaldo: true,
    image: "/fotos/saldos/AR19296.jpg",
    gender: "",
    color: "",
    material: "",
    shape: "",
    style: "",
    faceShape: [],
    description:
      "[TEXTO A REVER] Artigo de saldos da Óptica 13. Descrição detalhada em preparação — contacte-nos ou visite a loja para mais informações sobre este modelo.",
  },
  {
    id: 20063,
    codigo: "AR20016",
    slug: "estygma-ar20016",
    name: "ESTYGMA C2 C2",
    brand: "Estygma",
    category: "Aros",
    price: 50,
    originalPrice: 99,
    discountPct: 50,
    badge: "Saldos",
    isSaldo: true,
    image: "/fotos/saldos/AR20016.jpg",
    gender: "",
    color: "",
    material: "",
    shape: "",
    style: "",
    faceShape: [],
    description:
      "[TEXTO A REVER] Artigo de saldos da Óptica 13. Descrição detalhada em preparação — contacte-nos ou visite a loja para mais informações sobre este modelo.",
  },
  {
    id: 20064,
    codigo: "AR20017",
    slug: "estygma-ar20017",
    name: "ESTYGMA C3 C3",
    brand: "Estygma",
    category: "Aros",
    price: 50,
    originalPrice: 99,
    discountPct: 50,
    badge: "Saldos",
    isSaldo: true,
    image: "/fotos/saldos/AR20017.jpg",
    gender: "",
    color: "",
    material: "",
    shape: "",
    style: "",
    faceShape: [],
    description:
      "[TEXTO A REVER] Artigo de saldos da Óptica 13. Descrição detalhada em preparação — contacte-nos ou visite a loja para mais informações sobre este modelo.",
  },
  {
    id: 20065,
    codigo: "AR20021",
    slug: "estygma-ar20021",
    name: "ESTYGMA ML1000 C1",
    brand: "Estygma",
    category: "Aros",
    price: 50,
    originalPrice: 99,
    discountPct: 50,
    badge: "Saldos",
    isSaldo: true,
    image: "/fotos/saldos/AR20021.jpg",
    gender: "",
    color: "",
    material: "",
    shape: "",
    style: "",
    faceShape: [],
    description:
      "[TEXTO A REVER] Artigo de saldos da Óptica 13. Descrição detalhada em preparação — contacte-nos ou visite a loja para mais informações sobre este modelo.",
  },
  {
    id: 20066,
    codigo: "AR17035",
    slug: "etnia-barcelona-ar17035",
    name: "ETNIA BARCELONA MURPHY.BLBR51-14 130",
    brand: "Etnia Barcelona",
    category: "Aros",
    price: 64,
    originalPrice: 128,
    discountPct: 50,
    badge: "Saldos",
    isSaldo: true,
    image: "/fotos/saldos/AR17035.jpg",
    gender: "",
    color: "",
    material: "",
    shape: "",
    style: "",
    faceShape: [],
    description:
      "[TEXTO A REVER] Artigo de saldos da Óptica 13. Descrição detalhada em preparação — contacte-nos ou visite a loja para mais informações sobre este modelo.",
  },
  {
    id: 20067,
    codigo: "AR19785",
    slug: "etnia-barcelona-debbie-gdbl-ar19785",
    name: "ETNIA BARCELONA DEBBIE GDBL",
    brand: "Etnia Barcelona Debbie Gdbl",
    category: "Aros",
    price: 92,
    originalPrice: 183,
    discountPct: 50,
    badge: "Saldos",
    isSaldo: true,
    image: "/fotos/saldos/AR19785.jpg",
    gender: "",
    color: "",
    material: "",
    shape: "",
    style: "",
    faceShape: [],
    description:
      "[TEXTO A REVER] Artigo de saldos da Óptica 13. Descrição detalhada em preparação — contacte-nos ou visite a loja para mais informações sobre este modelo.",
  },
  {
    id: 20068,
    codigo: "AR19718",
    slug: "etnia-barcelona-huxley-ywbk-ar19718",
    name: "ETNIA BARCELONA HUXLEY YWBK",
    brand: "Etnia Barcelona Huxley Ywbk",
    category: "Aros",
    price: 22,
    originalPrice: 44,
    discountPct: 50,
    badge: "Saldos",
    isSaldo: true,
    image: "/fotos/saldos/AR19718.jpg",
    gender: "",
    color: "",
    material: "",
    shape: "",
    style: "",
    faceShape: [],
    description:
      "[TEXTO A REVER] Artigo de saldos da Óptica 13. Descrição detalhada em preparação — contacte-nos ou visite a loja para mais informações sobre este modelo.",
  },
  {
    id: 20069,
    codigo: "AR18924",
    slug: "etnia-barcelona-joshua-tree-ar18924",
    name: "ETNIA BARCELONA JOSHUA TREE 3BZBK 54/18",
    brand: "Etnia Barcelona Joshua Tree",
    category: "Aros",
    price: 65,
    originalPrice: 130,
    discountPct: 50,
    badge: "Saldos",
    isSaldo: true,
    image: "/fotos/saldos/AR18924.jpg",
    gender: "",
    color: "",
    material: "",
    shape: "",
    style: "",
    faceShape: [],
    description:
      "[TEXTO A REVER] Artigo de saldos da Óptica 13. Descrição detalhada em preparação — contacte-nos ou visite a loja para mais informações sobre este modelo.",
  },
  {
    id: 20070,
    codigo: "AR19796",
    slug: "etnia-barcelona-loredana-pgrd-ar19796",
    name: "ETNIA BARCELONA LOREDANA PGRD",
    brand: "Etnia Barcelona Loredana Pgrd",
    category: "Aros",
    price: 92,
    originalPrice: 183,
    discountPct: 50,
    badge: "Saldos",
    isSaldo: true,
    image: "/fotos/saldos/AR19796.jpg",
    gender: "",
    color: "",
    material: "",
    shape: "",
    style: "",
    faceShape: [],
    description:
      "[TEXTO A REVER] Artigo de saldos da Óptica 13. Descrição detalhada em preparação — contacte-nos ou visite a loja para mais informações sobre este modelo.",
  },
  {
    id: 20071,
    codigo: "AR19771",
    slug: "etnia-barcelona-maddox-hvbl-ar19771",
    name: "ETNIA BARCELONA MADDOX HVBL",
    brand: "Etnia Barcelona Maddox Hvbl",
    category: "Aros",
    price: 93,
    originalPrice: 186,
    discountPct: 50,
    badge: "Saldos",
    isSaldo: true,
    image: "/fotos/saldos/AR19771.jpg",
    gender: "",
    color: "",
    material: "",
    shape: "",
    style: "",
    faceShape: [],
    description:
      "[TEXTO A REVER] Artigo de saldos da Óptica 13. Descrição detalhada em preparação — contacte-nos ou visite a loja para mais informações sobre este modelo.",
  },
  {
    id: 20072,
    codigo: "AR19794",
    slug: "etnia-barcelona-mary-gyrd-ar19794",
    name: "ETNIA BARCELONA MARY GYRD",
    brand: "Etnia Barcelona Mary Gyrd",
    category: "Aros",
    price: 83,
    originalPrice: 165,
    discountPct: 50,
    badge: "Saldos",
    isSaldo: true,
    image: "/fotos/saldos/AR19794.jpg",
    gender: "",
    color: "",
    material: "",
    shape: "",
    style: "",
    faceShape: [],
    description:
      "[TEXTO A REVER] Artigo de saldos da Óptica 13. Descrição detalhada em preparação — contacte-nos ou visite a loja para mais informações sobre este modelo.",
  },
  {
    id: 20073,
    codigo: "AR19782",
    slug: "etnia-barcelona-times-square-blpg-ar19782",
    name: "ETNIA BARCELONA TIMES SQUARE BLPG",
    brand: "Etnia Barcelona Times Square Blpg",
    category: "Aros",
    price: 76,
    originalPrice: 151,
    discountPct: 50,
    badge: "Saldos",
    isSaldo: true,
    image: "/fotos/saldos/AR19782.jpg",
    gender: "",
    color: "",
    material: "",
    shape: "",
    style: "",
    faceShape: [],
    description:
      "[TEXTO A REVER] Artigo de saldos da Óptica 13. Descrição detalhada em preparação — contacte-nos ou visite a loja para mais informações sobre este modelo.",
  },
  {
    id: 20074,
    codigo: "AR15050",
    slug: "faconnable-ar15050",
    name: "FAÇONNABLE NV190.430",
    brand: "Façonnable",
    category: "Aros",
    price: 128,
    originalPrice: 255,
    discountPct: 50,
    badge: "Saldos",
    isSaldo: true,
    image: "/fotos/saldos/AR15050.jpg",
    gender: "",
    color: "",
    material: "",
    shape: "",
    style: "",
    faceShape: [],
    description:
      "[TEXTO A REVER] Artigo de saldos da Óptica 13. Descrição detalhada em preparação — contacte-nos ou visite a loja para mais informações sobre este modelo.",
  },
  {
    id: 20075,
    codigo: "AR15053",
    slug: "faconnable-ar15053",
    name: "FAÇONNABLE NV185.002",
    brand: "Façonnable",
    category: "Aros",
    price: 129,
    originalPrice: 258,
    discountPct: 50,
    badge: "Saldos",
    isSaldo: true,
    image: "/fotos/saldos/AR15053.jpg",
    gender: "",
    color: "",
    material: "",
    shape: "",
    style: "",
    faceShape: [],
    description:
      "[TEXTO A REVER] Artigo de saldos da Óptica 13. Descrição detalhada em preparação — contacte-nos ou visite a loja para mais informações sobre este modelo.",
  },
  {
    id: 20076,
    codigo: "AR18664",
    slug: "furla-ar18664",
    name: "FURLA VFU392 0700 53/16",
    brand: "Furla",
    category: "Aros",
    price: 73,
    originalPrice: 145,
    discountPct: 50,
    badge: "Saldos",
    isSaldo: true,
    image: "/fotos/saldos/AR18664.jpg",
    gender: "",
    color: "",
    material: "",
    shape: "",
    style: "",
    faceShape: [],
    description:
      "[TEXTO A REVER] Artigo de saldos da Óptica 13. Descrição detalhada em preparação — contacte-nos ou visite a loja para mais informações sobre este modelo.",
  },
  {
    id: 20077,
    codigo: "OS13834",
    slug: "furla-os13834",
    name: "FURLA SFU337 0700 54/19",
    brand: "Furla",
    category: "Óculos de Sol",
    price: 82,
    originalPrice: 164,
    discountPct: 50,
    badge: "Saldos",
    isSaldo: true,
    image: "/fotos/saldos/OS13834.jpg",
    gender: "",
    color: "",
    material: "",
    shape: "",
    style: "",
    faceShape: [],
    description:
      "[TEXTO A REVER] Artigo de saldos da Óptica 13. Descrição detalhada em preparação — contacte-nos ou visite a loja para mais informações sobre este modelo.",
  },
  {
    id: 20078,
    codigo: "OS13836",
    slug: "furla-os13836",
    name: "FURLA SFU405V 700Y 53/19",
    brand: "Furla",
    category: "Óculos de Sol",
    price: 104,
    originalPrice: 208,
    discountPct: 50,
    badge: "Saldos",
    isSaldo: true,
    image: "/fotos/saldos/OS13836.jpg",
    gender: "",
    color: "",
    material: "",
    shape: "",
    style: "",
    faceShape: [],
    description:
      "[TEXTO A REVER] Artigo de saldos da Óptica 13. Descrição detalhada em preparação — contacte-nos ou visite a loja para mais informações sobre este modelo.",
  },
  {
    id: 20079,
    codigo: "AR19437",
    slug: "gant-ar19437",
    name: "GANT GA3201 001 57/16",
    brand: "Gant",
    category: "Aros",
    price: 65,
    originalPrice: 129,
    discountPct: 50,
    badge: "Saldos",
    isSaldo: true,
    image: "/fotos/saldos/AR19437.jpg",
    gender: "",
    color: "",
    material: "",
    shape: "",
    style: "",
    faceShape: [],
    description:
      "[TEXTO A REVER] Artigo de saldos da Óptica 13. Descrição detalhada em preparação — contacte-nos ou visite a loja para mais informações sobre este modelo.",
  },
  {
    id: 20080,
    codigo: "AR19442",
    slug: "gant-ar19442",
    name: "GANT GA3254 001 57/15",
    brand: "Gant",
    category: "Aros",
    price: 64,
    originalPrice: 128,
    discountPct: 50,
    badge: "Saldos",
    isSaldo: true,
    image: "/fotos/saldos/AR19442.jpg",
    gender: "",
    color: "",
    material: "",
    shape: "",
    style: "",
    faceShape: [],
    description:
      "[TEXTO A REVER] Artigo de saldos da Óptica 13. Descrição detalhada em preparação — contacte-nos ou visite a loja para mais informações sobre este modelo.",
  },
  {
    id: 20081,
    codigo: "AR19445",
    slug: "gant-ar19445",
    name: "GANT GA4090 001 50/17",
    brand: "Gant",
    category: "Aros",
    price: 70,
    originalPrice: 139,
    discountPct: 50,
    badge: "Saldos",
    isSaldo: true,
    image: "/fotos/saldos/AR19445.jpg",
    gender: "",
    color: "",
    material: "",
    shape: "",
    style: "",
    faceShape: [],
    description:
      "[TEXTO A REVER] Artigo de saldos da Óptica 13. Descrição detalhada em preparação — contacte-nos ou visite a loja para mais informações sobre este modelo.",
  },
  {
    id: 20082,
    codigo: "OS12360",
    slug: "gant-os12360",
    name: "GANT 7015.GLD-103G",
    brand: "Gant",
    category: "Óculos de Sol",
    price: 68,
    originalPrice: 135,
    discountPct: 50,
    badge: "Saldos",
    isSaldo: true,
    image: "/fotos/saldos/OS12360.jpg",
    gender: "",
    color: "",
    material: "",
    shape: "",
    style: "",
    faceShape: [],
    description:
      "[TEXTO A REVER] Artigo de saldos da Óptica 13. Descrição detalhada em preparação — contacte-nos ou visite a loja para mais informações sobre este modelo.",
  },
  {
    id: 20083,
    codigo: "AR15642",
    slug: "green-ar15642",
    name: "GREEN V3.3..2MNER",
    brand: "Green",
    category: "Aros",
    price: 39,
    originalPrice: 78,
    discountPct: 50,
    badge: "Saldos",
    isSaldo: true,
    image: "/fotos/saldos/AR15642.jpg",
    gender: "",
    color: "",
    material: "",
    shape: "",
    style: "",
    faceShape: [],
    description:
      "[TEXTO A REVER] Artigo de saldos da Óptica 13. Descrição detalhada em preparação — contacte-nos ou visite a loja para mais informações sobre este modelo.",
  },
  {
    id: 20084,
    codigo: "AR15645",
    slug: "green-ar15645",
    name: "GREEN V3.3.16MVER",
    brand: "Green",
    category: "Aros",
    price: 39,
    originalPrice: 78,
    discountPct: 50,
    badge: "Saldos",
    isSaldo: true,
    image: "/fotos/saldos/AR15645.jpg",
    gender: "",
    color: "",
    material: "",
    shape: "",
    style: "",
    faceShape: [],
    description:
      "[TEXTO A REVER] Artigo de saldos da Óptica 13. Descrição detalhada em preparação — contacte-nos ou visite a loja para mais informações sobre este modelo.",
  },
  {
    id: 20085,
    codigo: "AR15657",
    slug: "green-ar15657",
    name: "GREEN V2.6.04BLU",
    brand: "Green",
    category: "Aros",
    price: 39,
    originalPrice: 78,
    discountPct: 50,
    badge: "Saldos",
    isSaldo: true,
    image: "/fotos/saldos/AR15657.jpg",
    gender: "",
    color: "",
    material: "",
    shape: "",
    style: "",
    faceShape: [],
    description:
      "[TEXTO A REVER] Artigo de saldos da Óptica 13. Descrição detalhada em preparação — contacte-nos ou visite a loja para mais informações sobre este modelo.",
  },
  {
    id: 20086,
    codigo: "AR15993",
    slug: "green-ar15993",
    name: "GREEN V4.3. C02M",
    brand: "Green",
    category: "Aros",
    price: 42,
    originalPrice: 84,
    discountPct: 50,
    badge: "Saldos",
    isSaldo: true,
    image: "/fotos/saldos/AR15993.jpg",
    gender: "",
    color: "",
    material: "",
    shape: "",
    style: "",
    faceShape: [],
    description:
      "[TEXTO A REVER] Artigo de saldos da Óptica 13. Descrição detalhada em preparação — contacte-nos ou visite a loja para mais informações sobre este modelo.",
  },
  {
    id: 20087,
    codigo: "AR19874",
    slug: "guess-ar19874",
    name: "GUESS GU2907 083 53/15",
    brand: "Guess",
    category: "Aros",
    price: 68,
    originalPrice: 136,
    discountPct: 50,
    badge: "Saldos",
    isSaldo: true,
    image: "/fotos/saldos/AR19874.jpg",
    gender: "",
    color: "",
    material: "",
    shape: "",
    style: "",
    faceShape: [],
    description:
      "[TEXTO A REVER] Artigo de saldos da Óptica 13. Descrição detalhada em preparação — contacte-nos ou visite a loja para mais informações sobre este modelo.",
  },
  {
    id: 20088,
    codigo: "AR19876",
    slug: "guess-ar19876",
    name: "GUESS GU2913 028 50/18",
    brand: "Guess",
    category: "Aros",
    price: 74,
    originalPrice: 148,
    discountPct: 50,
    badge: "Saldos",
    isSaldo: true,
    image: "/fotos/saldos/AR19876.jpg",
    gender: "",
    color: "",
    material: "",
    shape: "",
    style: "",
    faceShape: [],
    description:
      "[TEXTO A REVER] Artigo de saldos da Óptica 13. Descrição detalhada em preparação — contacte-nos ou visite a loja para mais informações sobre este modelo.",
  },
  {
    id: 20089,
    codigo: "AR19878",
    slug: "guess-ar19878",
    name: "GUESS GU2942 001 54/16",
    brand: "Guess",
    category: "Aros",
    price: 72,
    originalPrice: 144,
    discountPct: 50,
    badge: "Saldos",
    isSaldo: true,
    image: "/fotos/saldos/AR19878.jpg",
    gender: "",
    color: "",
    material: "",
    shape: "",
    style: "",
    faceShape: [],
    description:
      "[TEXTO A REVER] Artigo de saldos da Óptica 13. Descrição detalhada em preparação — contacte-nos ou visite a loja para mais informações sobre este modelo.",
  },
  {
    id: 20090,
    codigo: "AR19896",
    slug: "guess-ar19896",
    name: "GUESS GU2882 092",
    brand: "Guess",
    category: "Aros",
    price: 80,
    originalPrice: 160,
    discountPct: 50,
    badge: "Saldos",
    isSaldo: true,
    image: "/fotos/saldos/AR19896.jpg",
    gender: "",
    color: "",
    material: "",
    shape: "",
    style: "",
    faceShape: [],
    description:
      "[TEXTO A REVER] Artigo de saldos da Óptica 13. Descrição detalhada em preparação — contacte-nos ou visite a loja para mais informações sobre este modelo.",
  },
  {
    id: 20091,
    codigo: "OS13300",
    slug: "hally-son-os13300",
    name: "HALLY & SON HS603 V01",
    brand: "Hally & Son",
    category: "Óculos de Sol",
    price: 0,
    originalPrice: 0,
    discountPct: 50,
    badge: "Saldos",
    isSaldo: true,
    image: "/fotos/saldos/OS13300.jpg",
    gender: "",
    color: "",
    material: "",
    shape: "",
    style: "",
    faceShape: [],
    description:
      "[TEXTO A REVER] Artigo de saldos da Óptica 13. Descrição detalhada em preparação — contacte-nos ou visite a loja para mais informações sobre este modelo.",
  },
  {
    id: 20092,
    codigo: "OS13306",
    slug: "hally-son-os13306",
    name: "HALLY & SON HS659 S04",
    brand: "Hally & Son",
    category: "Óculos de Sol",
    price: 74,
    originalPrice: 148,
    discountPct: 50,
    badge: "Saldos",
    isSaldo: true,
    image: "/fotos/saldos/OS13306.jpg",
    gender: "",
    color: "",
    material: "",
    shape: "",
    style: "",
    faceShape: [],
    description:
      "[TEXTO A REVER] Artigo de saldos da Óptica 13. Descrição detalhada em preparação — contacte-nos ou visite a loja para mais informações sobre este modelo.",
  },
  {
    id: 20093,
    codigo: "OS13857",
    slug: "havaianas-canoa-os13857",
    name: "HAVAIANAS CANOA QFU9O 52/18",
    brand: "Havaianas Canoa",
    category: "Óculos de Sol",
    price: 39,
    originalPrice: 77,
    discountPct: 50,
    badge: "Saldos",
    isSaldo: true,
    image: "/fotos/saldos/OS13857.jpg",
    gender: "",
    color: "",
    material: "",
    shape: "",
    style: "",
    faceShape: [],
    description:
      "[TEXTO A REVER] Artigo de saldos da Óptica 13. Descrição detalhada em preparação — contacte-nos ou visite a loja para mais informações sobre este modelo.",
  },
  {
    id: 20094,
    codigo: "AR19426",
    slug: "havaianas-floripa-cs-ar19426",
    name: "HAVAIANAS FLORIPA/CS MR899 49/20",
    brand: "Havaianas Floripa/Cs",
    category: "Aros",
    price: 72,
    originalPrice: 144,
    discountPct: 50,
    badge: "Saldos",
    isSaldo: true,
    image: "/fotos/saldos/AR19426.jpg",
    gender: "",
    color: "",
    material: "",
    shape: "",
    style: "",
    faceShape: [],
    description:
      "[TEXTO A REVER] Artigo de saldos da Óptica 13. Descrição detalhada em preparação — contacte-nos ou visite a loja para mais informações sobre este modelo.",
  },
  {
    id: 20095,
    codigo: "OS14027",
    slug: "havaianas-sampa-os14027",
    name: "HAVAIANAS SAMPA 807IR 51/20",
    brand: "Havaianas Sampa",
    category: "Óculos de Sol",
    price: 37,
    originalPrice: 74,
    discountPct: 50,
    badge: "Saldos",
    isSaldo: true,
    image: "/fotos/saldos/OS14027.jpg",
    gender: "",
    color: "",
    material: "",
    shape: "",
    style: "",
    faceShape: [],
    description:
      "[TEXTO A REVER] Artigo de saldos da Óptica 13. Descrição detalhada em preparação — contacte-nos ou visite a loja para mais informações sobre este modelo.",
  },
  {
    id: 20096,
    codigo: "AR18529",
    slug: "hickmann-ar18529",
    name: "HICKMANN HI1128 09A 55/18",
    brand: "Hickmann",
    category: "Aros",
    price: 51,
    originalPrice: 102,
    discountPct: 50,
    badge: "Saldos",
    isSaldo: true,
    image: "/fotos/saldos/AR18529.jpg",
    gender: "",
    color: "",
    material: "",
    shape: "",
    style: "",
    faceShape: [],
    description:
      "[TEXTO A REVER] Artigo de saldos da Óptica 13. Descrição detalhada em preparação — contacte-nos ou visite a loja para mais informações sobre este modelo.",
  },
  {
    id: 20097,
    codigo: "AR19336",
    slug: "hickmann-ar19336",
    name: "HICKMANN HI6219 A01 53/16.5",
    brand: "Hickmann",
    category: "Aros",
    price: 51,
    originalPrice: 102,
    discountPct: 50,
    badge: "Saldos",
    isSaldo: true,
    image: "/fotos/saldos/AR19336.jpg",
    gender: "",
    color: "",
    material: "",
    shape: "",
    style: "",
    faceShape: [],
    description:
      "[TEXTO A REVER] Artigo de saldos da Óptica 13. Descrição detalhada em preparação — contacte-nos ou visite a loja para mais informações sobre este modelo.",
  },
  {
    id: 20098,
    codigo: "AR16119",
    slug: "hugo-boss-ar16119",
    name: "HUGO BOSS 0643.259",
    brand: "Hugo Boss",
    category: "Aros",
    price: 54,
    originalPrice: 108,
    discountPct: 50,
    badge: "Saldos",
    isSaldo: true,
    image: "/fotos/saldos/AR16119.jpg",
    gender: "",
    color: "",
    material: "",
    shape: "",
    style: "",
    faceShape: [],
    description:
      "[TEXTO A REVER] Artigo de saldos da Óptica 13. Descrição detalhada em preparação — contacte-nos ou visite a loja para mais informações sobre este modelo.",
  },
  {
    id: 20099,
    codigo: "AR18726",
    slug: "hugo-boss-ar18726",
    name: "HUGO BOSS 1133 807 54/17",
    brand: "Hugo Boss",
    category: "Aros",
    price: 134,
    originalPrice: 268,
    discountPct: 50,
    badge: "Saldos",
    isSaldo: true,
    image: "/fotos/saldos/AR18726.jpg",
    gender: "",
    color: "",
    material: "",
    shape: "",
    style: "",
    faceShape: [],
    description:
      "[TEXTO A REVER] Artigo de saldos da Óptica 13. Descrição detalhada em preparação — contacte-nos ou visite a loja para mais informações sobre este modelo.",
  },
  {
    id: 20100,
    codigo: "AR19033",
    slug: "hugo-boss-ar19033",
    name: "HUGO BOSS 1297/F 003 57/17",
    brand: "Hugo Boss",
    category: "Aros",
    price: 121,
    originalPrice: 242,
    discountPct: 50,
    badge: "Saldos",
    isSaldo: true,
    image: "/fotos/saldos/AR19033.jpg",
    gender: "",
    color: "",
    material: "",
    shape: "",
    style: "",
    faceShape: [],
    description:
      "[TEXTO A REVER] Artigo de saldos da Óptica 13. Descrição detalhada em preparação — contacte-nos ou visite a loja para mais informações sobre este modelo.",
  },
  {
    id: 20101,
    codigo: "AR19408",
    slug: "hugo-boss-ar19408",
    name: "HUGO BOSS 1084/T 807 56/16",
    brand: "Hugo Boss",
    category: "Aros",
    price: 110,
    originalPrice: 220,
    discountPct: 50,
    badge: "Saldos",
    isSaldo: true,
    image: "/fotos/saldos/AR19408.jpg",
    gender: "",
    color: "",
    material: "",
    shape: "",
    style: "",
    faceShape: [],
    description:
      "[TEXTO A REVER] Artigo de saldos da Óptica 13. Descrição detalhada em preparação — contacte-nos ou visite a loja para mais informações sobre este modelo.",
  },
  {
    id: 20102,
    codigo: "AR19410",
    slug: "hugo-boss-ar19410",
    name: "HUGO BOSS 1338 RHL 53/18",
    brand: "Hugo Boss",
    category: "Aros",
    price: 118,
    originalPrice: 236,
    discountPct: 50,
    badge: "Saldos",
    isSaldo: true,
    image: "/fotos/saldos/AR19410.jpg",
    gender: "",
    color: "",
    material: "",
    shape: "",
    style: "",
    faceShape: [],
    description:
      "[TEXTO A REVER] Artigo de saldos da Óptica 13. Descrição detalhada em preparação — contacte-nos ou visite a loja para mais informações sobre este modelo.",
  },
  {
    id: 20103,
    codigo: "AR19414",
    slug: "hugo-boss-ar19414",
    name: "HUGO BOSS 1390 086 55/15",
    brand: "Hugo Boss",
    category: "Aros",
    price: 100,
    originalPrice: 199,
    discountPct: 50,
    badge: "Saldos",
    isSaldo: true,
    image: "/fotos/saldos/AR19414.jpg",
    gender: "",
    color: "",
    material: "",
    shape: "",
    style: "",
    faceShape: [],
    description:
      "[TEXTO A REVER] Artigo de saldos da Óptica 13. Descrição detalhada em preparação — contacte-nos ou visite a loja para mais informações sobre este modelo.",
  },
  {
    id: 20104,
    codigo: "AR16065",
    slug: "i-love-you-ar16065",
    name: "I LOVE YOU 43270.C1",
    brand: "I Love You",
    category: "Aros",
    price: 16,
    originalPrice: 32,
    discountPct: 50,
    badge: "Saldos",
    isSaldo: true,
    image: "/fotos/saldos/AR16065.jpg",
    gender: "",
    color: "",
    material: "",
    shape: "",
    style: "",
    faceShape: [],
    description:
      "[TEXTO A REVER] Artigo de saldos da Óptica 13. Descrição detalhada em preparação — contacte-nos ou visite a loja para mais informações sobre este modelo.",
  },
  {
    id: 20105,
    codigo: "AR17441",
    slug: "i-love-you-ar17441",
    name: "I LOVE YOU 41411.C3",
    brand: "I Love You",
    category: "Aros",
    price: 16,
    originalPrice: 32,
    discountPct: 50,
    badge: "Saldos",
    isSaldo: true,
    image: "/fotos/saldos/AR17441.jpg",
    gender: "",
    color: "",
    material: "",
    shape: "",
    style: "",
    faceShape: [],
    description:
      "[TEXTO A REVER] Artigo de saldos da Óptica 13. Descrição detalhada em preparação — contacte-nos ou visite a loja para mais informações sobre este modelo.",
  },
  {
    id: 20106,
    codigo: "AR17442",
    slug: "i-love-you-ar17442",
    name: "I LOVE YOU 41415.C1",
    brand: "I Love You",
    category: "Aros",
    price: 16,
    originalPrice: 32,
    discountPct: 50,
    badge: "Saldos",
    isSaldo: true,
    image: "/fotos/saldos/AR17442.jpg",
    gender: "",
    color: "",
    material: "",
    shape: "",
    style: "",
    faceShape: [],
    description:
      "[TEXTO A REVER] Artigo de saldos da Óptica 13. Descrição detalhada em preparação — contacte-nos ou visite a loja para mais informações sobre este modelo.",
  },
  {
    id: 20107,
    codigo: "AR17447",
    slug: "i-love-you-ar17447",
    name: "I LOVE YOU 41390.C3",
    brand: "I Love You",
    category: "Aros",
    price: 16,
    originalPrice: 32,
    discountPct: 50,
    badge: "Saldos",
    isSaldo: true,
    image: "/fotos/saldos/AR17447.jpg",
    gender: "",
    color: "",
    material: "",
    shape: "",
    style: "",
    faceShape: [],
    description:
      "[TEXTO A REVER] Artigo de saldos da Óptica 13. Descrição detalhada em preparação — contacte-nos ou visite a loja para mais informações sobre este modelo.",
  },
  {
    id: 20108,
    codigo: "AR15995",
    slug: "igreen-ar15995",
    name: "IGREEN V4.10.C09",
    brand: "Igreen",
    category: "Aros",
    price: 42,
    originalPrice: 84,
    discountPct: 50,
    badge: "Saldos",
    isSaldo: true,
    image: "/fotos/saldos/AR15995.jpg",
    gender: "",
    color: "",
    material: "",
    shape: "",
    style: "",
    faceShape: [],
    description:
      "[TEXTO A REVER] Artigo de saldos da Óptica 13. Descrição detalhada em preparação — contacte-nos ou visite a loja para mais informações sobre este modelo.",
  },
  {
    id: 20109,
    codigo: "OS13236",
    slug: "invu-os13236",
    name: "INVU K1802 B",
    brand: "Invu",
    category: "Óculos de Sol",
    price: 23,
    originalPrice: 46,
    discountPct: 50,
    badge: "Saldos",
    isSaldo: true,
    image: "/fotos/saldos/OS13236.jpg",
    gender: "",
    color: "",
    material: "",
    shape: "",
    style: "",
    faceShape: [],
    description:
      "[TEXTO A REVER] Artigo de saldos da Óptica 13. Descrição detalhada em preparação — contacte-nos ou visite a loja para mais informações sobre este modelo.",
  },
  {
    id: 20110,
    codigo: "OS13549",
    slug: "invu-os13549",
    name: "INVU B1817 C",
    brand: "Invu",
    category: "Óculos de Sol",
    price: 36,
    originalPrice: 72,
    discountPct: 50,
    badge: "Saldos",
    isSaldo: true,
    image: "/fotos/saldos/OS13549.jpg",
    gender: "",
    color: "",
    material: "",
    shape: "",
    style: "",
    faceShape: [],
    description:
      "[TEXTO A REVER] Artigo de saldos da Óptica 13. Descrição detalhada em preparação — contacte-nos ou visite a loja para mais informações sobre este modelo.",
  },
  {
    id: 20111,
    codigo: "OS13556",
    slug: "invu-os13556",
    name: "INVU T2901 B",
    brand: "Invu",
    category: "Óculos de Sol",
    price: 25,
    originalPrice: 49,
    discountPct: 50,
    badge: "Saldos",
    isSaldo: true,
    image: "/fotos/saldos/OS13556.jpg",
    gender: "",
    color: "",
    material: "",
    shape: "",
    style: "",
    faceShape: [],
    description:
      "[TEXTO A REVER] Artigo de saldos da Óptica 13. Descrição detalhada em preparação — contacte-nos ou visite a loja para mais informações sobre este modelo.",
  },
  {
    id: 20112,
    codigo: "OS13558",
    slug: "invu-os13558",
    name: "INVU T2910 B",
    brand: "Invu",
    category: "Óculos de Sol",
    price: 22,
    originalPrice: 44,
    discountPct: 50,
    badge: "Saldos",
    isSaldo: true,
    image: "/fotos/saldos/OS13558.jpg",
    gender: "",
    color: "",
    material: "",
    shape: "",
    style: "",
    faceShape: [],
    description:
      "[TEXTO A REVER] Artigo de saldos da Óptica 13. Descrição detalhada em preparação — contacte-nos ou visite a loja para mais informações sobre este modelo.",
  },
  {
    id: 20113,
    codigo: "OS13573",
    slug: "invu-os13573",
    name: "INVU B2933 C",
    brand: "Invu",
    category: "Óculos de Sol",
    price: 31,
    originalPrice: 61,
    discountPct: 50,
    badge: "Saldos",
    isSaldo: true,
    image: "/fotos/saldos/OS13573.jpg",
    gender: "",
    color: "",
    material: "",
    shape: "",
    style: "",
    faceShape: [],
    description:
      "[TEXTO A REVER] Artigo de saldos da Óptica 13. Descrição detalhada em preparação — contacte-nos ou visite a loja para mais informações sobre este modelo.",
  },
  {
    id: 20114,
    codigo: "OS13702",
    slug: "invu-os13702",
    name: "INVU A2902 F",
    brand: "Invu",
    category: "Óculos de Sol",
    price: 55,
    originalPrice: 110,
    discountPct: 50,
    badge: "Saldos",
    isSaldo: true,
    image: "/fotos/saldos/OS13702.jpg",
    gender: "",
    color: "",
    material: "",
    shape: "",
    style: "",
    faceShape: [],
    description:
      "[TEXTO A REVER] Artigo de saldos da Óptica 13. Descrição detalhada em preparação — contacte-nos ou visite a loja para mais informações sobre este modelo.",
  },
  {
    id: 20115,
    codigo: "OS13723",
    slug: "invu-os13723",
    name: "INVU B2009 A",
    brand: "Invu",
    category: "Óculos de Sol",
    price: 46,
    originalPrice: 91,
    discountPct: 50,
    badge: "Saldos",
    isSaldo: true,
    image: "/fotos/saldos/OS13723.jpg",
    gender: "",
    color: "",
    material: "",
    shape: "",
    style: "",
    faceShape: [],
    description:
      "[TEXTO A REVER] Artigo de saldos da Óptica 13. Descrição detalhada em preparação — contacte-nos ou visite a loja para mais informações sobre este modelo.",
  },
  {
    id: 20116,
    codigo: "OS13844",
    slug: "invu-os13844",
    name: "INVU B2006 A",
    brand: "Invu",
    category: "Óculos de Sol",
    price: 46,
    originalPrice: 91,
    discountPct: 50,
    badge: "Saldos",
    isSaldo: true,
    image: "/fotos/saldos/OS13844.jpg",
    gender: "",
    color: "",
    material: "",
    shape: "",
    style: "",
    faceShape: [],
    description:
      "[TEXTO A REVER] Artigo de saldos da Óptica 13. Descrição detalhada em preparação — contacte-nos ou visite a loja para mais informações sobre este modelo.",
  },
  {
    id: 20117,
    codigo: "OS13845",
    slug: "invu-os13845",
    name: "INVU B2028 A",
    brand: "Invu",
    category: "Óculos de Sol",
    price: 13,
    originalPrice: 26,
    discountPct: 50,
    badge: "Saldos",
    isSaldo: true,
    image: "/fotos/saldos/OS13845.jpg",
    gender: "",
    color: "",
    material: "",
    shape: "",
    style: "",
    faceShape: [],
    description:
      "[TEXTO A REVER] Artigo de saldos da Óptica 13. Descrição detalhada em preparação — contacte-nos ou visite a loja para mais informações sobre este modelo.",
  },
  {
    id: 20118,
    codigo: "OS13970",
    slug: "invu-os13970",
    name: "INVU B2024 C",
    brand: "Invu",
    category: "Óculos de Sol",
    price: 25,
    originalPrice: 49,
    discountPct: 50,
    badge: "Saldos",
    isSaldo: true,
    image: "/fotos/saldos/OS13970.jpg",
    gender: "",
    color: "",
    material: "",
    shape: "",
    style: "",
    faceShape: [],
    description:
      "[TEXTO A REVER] Artigo de saldos da Óptica 13. Descrição detalhada em preparação — contacte-nos ou visite a loja para mais informações sobre este modelo.",
  },
  {
    id: 20119,
    codigo: "AR19012",
    slug: "kristian-olsen-ar19012",
    name: "KRISTIAN OLSEN KF082 02 50/18",
    brand: "Kristian Olsen",
    category: "Aros",
    price: 29,
    originalPrice: 57,
    discountPct: 50,
    badge: "Saldos",
    isSaldo: true,
    image: "/fotos/saldos/AR19012.jpg",
    gender: "",
    color: "",
    material: "",
    shape: "",
    style: "",
    faceShape: [],
    description:
      "[TEXTO A REVER] Artigo de saldos da Óptica 13. Descrição detalhada em preparação — contacte-nos ou visite a loja para mais informações sobre este modelo.",
  },
  {
    id: 20120,
    codigo: "AR19019",
    slug: "kristian-olsen-ar19019",
    name: "KRISTIAN OLSEN KF179 03 55/15",
    brand: "Kristian Olsen",
    category: "Aros",
    price: 33,
    originalPrice: 65,
    discountPct: 50,
    badge: "Saldos",
    isSaldo: true,
    image: "/fotos/saldos/AR19019.jpg",
    gender: "",
    color: "",
    material: "",
    shape: "",
    style: "",
    faceShape: [],
    description:
      "[TEXTO A REVER] Artigo de saldos da Óptica 13. Descrição detalhada em preparação — contacte-nos ou visite a loja para mais informações sobre este modelo.",
  },
  {
    id: 20121,
    codigo: "AR19341",
    slug: "kristian-olsen-ar19341",
    name: "KRISTIAN OLSEN KF176 02 54/15",
    brand: "Kristian Olsen",
    category: "Aros",
    price: 33,
    originalPrice: 65,
    discountPct: 50,
    badge: "Saldos",
    isSaldo: true,
    image: "/fotos/saldos/AR19341.jpg",
    gender: "",
    color: "",
    material: "",
    shape: "",
    style: "",
    faceShape: [],
    description:
      "[TEXTO A REVER] Artigo de saldos da Óptica 13. Descrição detalhada em preparação — contacte-nos ou visite a loja para mais informações sobre este modelo.",
  },
  {
    id: 20122,
    codigo: "AR19346",
    slug: "kristian-olsen-ar19346",
    name: "KRISTIAN OLSEN KF215 1 51/22",
    brand: "Kristian Olsen",
    category: "Aros",
    price: 26,
    originalPrice: 52,
    discountPct: 50,
    badge: "Saldos",
    isSaldo: true,
    image: "/fotos/saldos/AR19346.jpg",
    gender: "",
    color: "",
    material: "",
    shape: "",
    style: "",
    faceShape: [],
    description:
      "[TEXTO A REVER] Artigo de saldos da Óptica 13. Descrição detalhada em preparação — contacte-nos ou visite a loja para mais informações sobre este modelo.",
  },
  {
    id: 20123,
    codigo: "AR19357",
    slug: "kristian-olsen-ar19357",
    name: "KRISTIAN OLSEN KF127 01 55/18",
    brand: "Kristian Olsen",
    category: "Aros",
    price: 26,
    originalPrice: 52,
    discountPct: 50,
    badge: "Saldos",
    isSaldo: true,
    image: "/fotos/saldos/AR19357.jpg",
    gender: "",
    color: "",
    material: "",
    shape: "",
    style: "",
    faceShape: [],
    description:
      "[TEXTO A REVER] Artigo de saldos da Óptica 13. Descrição detalhada em preparação — contacte-nos ou visite a loja para mais informações sobre este modelo.",
  },
  {
    id: 20124,
    codigo: "OS12646",
    slug: "lacoste-os12646",
    name: "LACOSTE L790S.61552-20 140",
    brand: "Lacoste",
    category: "Óculos de Sol",
    price: 65,
    originalPrice: 130,
    discountPct: 50,
    badge: "Saldos",
    isSaldo: true,
    image: "/fotos/saldos/OS12646.jpg",
    gender: "",
    color: "",
    material: "",
    shape: "",
    style: "",
    faceShape: [],
    description:
      "[TEXTO A REVER] Artigo de saldos da Óptica 13. Descrição detalhada em preparação — contacte-nos ou visite a loja para mais informações sobre este modelo.",
  },
  {
    id: 20125,
    codigo: "AR17109",
    slug: "lightec-ar17109",
    name: "LIGHTEC 7682L.BG042",
    brand: "Lightec",
    category: "Aros",
    price: 73,
    originalPrice: 146,
    discountPct: 50,
    badge: "Saldos",
    isSaldo: true,
    image: "/fotos/saldos/AR17109.jpg",
    gender: "",
    color: "",
    material: "",
    shape: "",
    style: "",
    faceShape: [],
    description:
      "[TEXTO A REVER] Artigo de saldos da Óptica 13. Descrição detalhada em preparação — contacte-nos ou visite a loja para mais informações sobre este modelo.",
  },
  {
    id: 20126,
    codigo: "AR17110",
    slug: "lightec-ar17110",
    name: "LIGHTEC 7684L.BN061",
    brand: "Lightec",
    category: "Aros",
    price: 73,
    originalPrice: 146,
    discountPct: 50,
    badge: "Saldos",
    isSaldo: true,
    image: "/fotos/saldos/AR17110.jpg",
    gender: "",
    color: "",
    material: "",
    shape: "",
    style: "",
    faceShape: [],
    description:
      "[TEXTO A REVER] Artigo de saldos da Óptica 13. Descrição detalhada em preparação — contacte-nos ou visite a loja para mais informações sobre este modelo.",
  },
  {
    id: 20127,
    codigo: "AR17125",
    slug: "lightec-ar17125",
    name: "LIGHTEC 8094L.BB020",
    brand: "Lightec",
    category: "Aros",
    price: 77,
    originalPrice: 153,
    discountPct: 50,
    badge: "Saldos",
    isSaldo: true,
    image: "/fotos/saldos/AR17125.jpg",
    gender: "",
    color: "",
    material: "",
    shape: "",
    style: "",
    faceShape: [],
    description:
      "[TEXTO A REVER] Artigo de saldos da Óptica 13. Descrição detalhada em preparação — contacte-nos ou visite a loja para mais informações sobre este modelo.",
  },
  {
    id: 20128,
    codigo: "AR2576",
    slug: "luxottica-ar2576",
    name: "LUXOTTICA 1016T.4030",
    brand: "Luxottica",
    category: "Aros",
    price: 73,
    originalPrice: 145,
    discountPct: 50,
    badge: "Saldos",
    isSaldo: true,
    image: "/fotos/saldos/AR2576.jpg",
    gender: "",
    color: "",
    material: "",
    shape: "",
    style: "",
    faceShape: [],
    description:
      "[TEXTO A REVER] Artigo de saldos da Óptica 13. Descrição detalhada em preparação — contacte-nos ou visite a loja para mais informações sobre este modelo.",
  },
  {
    id: 20129,
    codigo: "OS11303",
    slug: "lytot-os11303",
    name: "LYTOT LT001.C21",
    brand: "Lytot",
    category: "Óculos de Sol",
    price: 30,
    originalPrice: 60,
    discountPct: 50,
    badge: "Saldos",
    isSaldo: true,
    image: "/fotos/saldos/OS11303.jpg",
    gender: "",
    color: "",
    material: "",
    shape: "",
    style: "",
    faceShape: [],
    description:
      "[TEXTO A REVER] Artigo de saldos da Óptica 13. Descrição detalhada em preparação — contacte-nos ou visite a loja para mais informações sobre este modelo.",
  },
  {
    id: 20130,
    codigo: "OS11304",
    slug: "lytot-os11304",
    name: "LYTOT LT001.C22",
    brand: "Lytot",
    category: "Óculos de Sol",
    price: 30,
    originalPrice: 60,
    discountPct: 50,
    badge: "Saldos",
    isSaldo: true,
    image: "/fotos/saldos/OS11304.jpg",
    gender: "",
    color: "",
    material: "",
    shape: "",
    style: "",
    faceShape: [],
    description:
      "[TEXTO A REVER] Artigo de saldos da Óptica 13. Descrição detalhada em preparação — contacte-nos ou visite a loja para mais informações sobre este modelo.",
  },
  {
    id: 20131,
    codigo: "OS13921",
    slug: "maui-jim-os13921",
    name: "MAUI JIM MJ789 02S",
    brand: "Maui Jim",
    category: "Óculos de Sol",
    price: 171,
    originalPrice: 341,
    discountPct: 50,
    badge: "Saldos",
    isSaldo: true,
    image: "/fotos/saldos/OS13921.jpg",
    gender: "",
    color: "",
    material: "",
    shape: "",
    style: "",
    faceShape: [],
    description:
      "[TEXTO A REVER] Artigo de saldos da Óptica 13. Descrição detalhada em preparação — contacte-nos ou visite a loja para mais informações sobre este modelo.",
  },
  {
    id: 20132,
    codigo: "AR19860",
    slug: "michael-kors-ar19860",
    name: "MICHAEL KORS MK4087B 3006",
    brand: "Michael Kors",
    category: "Aros",
    price: 94,
    originalPrice: 188,
    discountPct: 50,
    badge: "Saldos",
    isSaldo: true,
    image: "/fotos/saldos/AR19860.jpg",
    gender: "",
    color: "",
    material: "",
    shape: "",
    style: "",
    faceShape: [],
    description:
      "[TEXTO A REVER] Artigo de saldos da Óptica 13. Descrição detalhada em preparação — contacte-nos ou visite a loja para mais informações sobre este modelo.",
  },
  {
    id: 20133,
    codigo: "AR19893",
    slug: "michael-kors-ar19893",
    name: "MICHAEL KORS MK4082 3006 5417",
    brand: "Michael Kors",
    category: "Aros",
    price: 81,
    originalPrice: 161,
    discountPct: 50,
    badge: "Saldos",
    isSaldo: true,
    image: "/fotos/saldos/AR19893.jpg",
    gender: "",
    color: "",
    material: "",
    shape: "",
    style: "",
    faceShape: [],
    description:
      "[TEXTO A REVER] Artigo de saldos da Óptica 13. Descrição detalhada em preparação — contacte-nos ou visite a loja para mais informações sobre este modelo.",
  },
  {
    id: 20134,
    codigo: "OS12971",
    slug: "michael-kors-os12971",
    name: "MICHAEL KORS MK2039.321611",
    brand: "Michael Kors",
    category: "Óculos de Sol",
    price: 63,
    originalPrice: 125,
    discountPct: 50,
    badge: "Saldos",
    isSaldo: true,
    image: "/fotos/saldos/OS12971.jpg",
    gender: "",
    color: "",
    material: "",
    shape: "",
    style: "",
    faceShape: [],
    description:
      "[TEXTO A REVER] Artigo de saldos da Óptica 13. Descrição detalhada em preparação — contacte-nos ou visite a loja para mais informações sobre este modelo.",
  },
  {
    id: 20135,
    codigo: "AR19143",
    slug: "mindthelook-by-vv-ar19143",
    name: "MindTheLook by VV K1200 1",
    brand: "Mindthelook By Vv",
    category: "Aros",
    price: 47,
    originalPrice: 94,
    discountPct: 50,
    badge: "Saldos",
    isSaldo: true,
    image: "/fotos/saldos/AR19143.jpg",
    gender: "",
    color: "",
    material: "",
    shape: "",
    style: "",
    faceShape: [],
    description:
      "[TEXTO A REVER] Artigo de saldos da Óptica 13. Descrição detalhada em preparação — contacte-nos ou visite a loja para mais informações sobre este modelo.",
  },
  {
    id: 20136,
    codigo: "AR19151",
    slug: "mindthelook-by-vv-ar19151",
    name: "MindTheLook by VV CL208 4",
    brand: "Mindthelook By Vv",
    category: "Aros",
    price: 53,
    originalPrice: 105,
    discountPct: 50,
    badge: "Saldos",
    isSaldo: true,
    image: "/fotos/saldos/AR19151.jpg",
    gender: "",
    color: "",
    material: "",
    shape: "",
    style: "",
    faceShape: [],
    description:
      "[TEXTO A REVER] Artigo de saldos da Óptica 13. Descrição detalhada em preparação — contacte-nos ou visite a loja para mais informações sobre este modelo.",
  },
  {
    id: 20137,
    codigo: "AR19153",
    slug: "mindthelook-by-vv-ar19153",
    name: "MindTheLook by VV CL222 1",
    brand: "Mindthelook By Vv",
    category: "Aros",
    price: 49,
    originalPrice: 97,
    discountPct: 50,
    badge: "Saldos",
    isSaldo: true,
    image: "/fotos/saldos/AR19153.jpg",
    gender: "",
    color: "",
    material: "",
    shape: "",
    style: "",
    faceShape: [],
    description:
      "[TEXTO A REVER] Artigo de saldos da Óptica 13. Descrição detalhada em preparação — contacte-nos ou visite a loja para mais informações sobre este modelo.",
  },
  {
    id: 20138,
    codigo: "AR19156",
    slug: "mindthelook-by-vv-ar19156",
    name: "MindTheLook by VV K1180 3",
    brand: "Mindthelook By Vv",
    category: "Aros",
    price: 44,
    originalPrice: 87,
    discountPct: 50,
    badge: "Saldos",
    isSaldo: true,
    image: "/fotos/saldos/AR19156.jpg",
    gender: "",
    color: "",
    material: "",
    shape: "",
    style: "",
    faceShape: [],
    description:
      "[TEXTO A REVER] Artigo de saldos da Óptica 13. Descrição detalhada em preparação — contacte-nos ou visite a loja para mais informações sobre este modelo.",
  },
  {
    id: 20139,
    codigo: "AR19159",
    slug: "mindthelook-by-vv-ar19159",
    name: "MindTheLook by VV K1200 3",
    brand: "Mindthelook By Vv",
    category: "Aros",
    price: 47,
    originalPrice: 94,
    discountPct: 50,
    badge: "Saldos",
    isSaldo: true,
    image: "/fotos/saldos/AR19159.jpg",
    gender: "",
    color: "",
    material: "",
    shape: "",
    style: "",
    faceShape: [],
    description:
      "[TEXTO A REVER] Artigo de saldos da Óptica 13. Descrição detalhada em preparação — contacte-nos ou visite a loja para mais informações sobre este modelo.",
  },
  {
    id: 20140,
    codigo: "AR19622",
    slug: "mindthelook-by-vv-ar19622",
    name: "MindTheLook by VV VV1303 C3 55/15",
    brand: "Mindthelook By Vv",
    category: "Aros",
    price: 67,
    originalPrice: 134,
    discountPct: 50,
    badge: "Saldos",
    isSaldo: true,
    image: "/fotos/saldos/AR19622.jpg",
    gender: "",
    color: "",
    material: "",
    shape: "",
    style: "",
    faceShape: [],
    description:
      "[TEXTO A REVER] Artigo de saldos da Óptica 13. Descrição detalhada em preparação — contacte-nos ou visite a loja para mais informações sobre este modelo.",
  },
  {
    id: 20141,
    codigo: "AR19629",
    slug: "mindthelook-by-vv-ar19629",
    name: "MindTheLook by VV VV1308 C1 49/20",
    brand: "Mindthelook By Vv",
    category: "Aros",
    price: 47,
    originalPrice: 94,
    discountPct: 50,
    badge: "Saldos",
    isSaldo: true,
    image: "/fotos/saldos/AR19629.jpg",
    gender: "",
    color: "",
    material: "",
    shape: "",
    style: "",
    faceShape: [],
    description:
      "[TEXTO A REVER] Artigo de saldos da Óptica 13. Descrição detalhada em preparação — contacte-nos ou visite a loja para mais informações sobre este modelo.",
  },
  {
    id: 20142,
    codigo: "AR19630",
    slug: "mindthelook-by-vv-ar19630",
    name: "MindTheLook by VV VV1308 C2 49/20",
    brand: "Mindthelook By Vv",
    category: "Aros",
    price: 47,
    originalPrice: 94,
    discountPct: 50,
    badge: "Saldos",
    isSaldo: true,
    image: "/fotos/saldos/AR19630.jpg",
    gender: "",
    color: "",
    material: "",
    shape: "",
    style: "",
    faceShape: [],
    description:
      "[TEXTO A REVER] Artigo de saldos da Óptica 13. Descrição detalhada em preparação — contacte-nos ou visite a loja para mais informações sobre este modelo.",
  },
  {
    id: 20143,
    codigo: "AR19632",
    slug: "mindthelook-by-vv-ar19632",
    name: "MindTheLook by VV VV1308 C4 49/20",
    brand: "Mindthelook By Vv",
    category: "Aros",
    price: 47,
    originalPrice: 94,
    discountPct: 50,
    badge: "Saldos",
    isSaldo: true,
    image: "/fotos/saldos/AR19632.jpg",
    gender: "",
    color: "",
    material: "",
    shape: "",
    style: "",
    faceShape: [],
    description:
      "[TEXTO A REVER] Artigo de saldos da Óptica 13. Descrição detalhada em preparação — contacte-nos ou visite a loja para mais informações sobre este modelo.",
  },
  {
    id: 20144,
    codigo: "AR19647",
    slug: "mindthelook-by-vv-ar19647",
    name: "MindTheLook by VV VV1215 C3 56/16",
    brand: "Mindthelook By Vv",
    category: "Aros",
    price: 38,
    originalPrice: 75,
    discountPct: 50,
    badge: "Saldos",
    isSaldo: true,
    image: "/fotos/saldos/AR19647.jpg",
    gender: "",
    color: "",
    material: "",
    shape: "",
    style: "",
    faceShape: [],
    description:
      "[TEXTO A REVER] Artigo de saldos da Óptica 13. Descrição detalhada em preparação — contacte-nos ou visite a loja para mais informações sobre este modelo.",
  },
  {
    id: 20145,
    codigo: "AR19652",
    slug: "mindthelook-by-vv-ar19652",
    name: "MindTheLook by VV VV1315 C1 56/17",
    brand: "Mindthelook By Vv",
    category: "Aros",
    price: 49,
    originalPrice: 97,
    discountPct: 50,
    badge: "Saldos",
    isSaldo: true,
    image: "/fotos/saldos/AR19652.jpg",
    gender: "",
    color: "",
    material: "",
    shape: "",
    style: "",
    faceShape: [],
    description:
      "[TEXTO A REVER] Artigo de saldos da Óptica 13. Descrição detalhada em preparação — contacte-nos ou visite a loja para mais informações sobre este modelo.",
  },
  {
    id: 20146,
    codigo: "AR19655",
    slug: "mindthelook-by-vv-ar19655",
    name: "MindTheLook by VV VV1316 C3 52/17",
    brand: "Mindthelook By Vv",
    category: "Aros",
    price: 67,
    originalPrice: 134,
    discountPct: 50,
    badge: "Saldos",
    isSaldo: true,
    image: "/fotos/saldos/AR19655.jpg",
    gender: "",
    color: "",
    material: "",
    shape: "",
    style: "",
    faceShape: [],
    description:
      "[TEXTO A REVER] Artigo de saldos da Óptica 13. Descrição detalhada em preparação — contacte-nos ou visite a loja para mais informações sobre este modelo.",
  },
  {
    id: 20147,
    codigo: "AR19656",
    slug: "mindthelook-by-vv-ar19656",
    name: "MindTheLook by VV VV1317 C1 53/17",
    brand: "Mindthelook By Vv",
    category: "Aros",
    price: 67,
    originalPrice: 134,
    discountPct: 50,
    badge: "Saldos",
    isSaldo: true,
    image: "/fotos/saldos/AR19656.jpg",
    gender: "",
    color: "",
    material: "",
    shape: "",
    style: "",
    faceShape: [],
    description:
      "[TEXTO A REVER] Artigo de saldos da Óptica 13. Descrição detalhada em preparação — contacte-nos ou visite a loja para mais informações sobre este modelo.",
  },
  {
    id: 20148,
    codigo: "AR19657",
    slug: "mindthelook-by-vv-ar19657",
    name: "MindTheLook by VV VV1317 C2 53/17",
    brand: "Mindthelook By Vv",
    category: "Aros",
    price: 67,
    originalPrice: 134,
    discountPct: 50,
    badge: "Saldos",
    isSaldo: true,
    image: "/fotos/saldos/AR19657.jpg",
    gender: "",
    color: "",
    material: "",
    shape: "",
    style: "",
    faceShape: [],
    description:
      "[TEXTO A REVER] Artigo de saldos da Óptica 13. Descrição detalhada em preparação — contacte-nos ou visite a loja para mais informações sobre este modelo.",
  },
  {
    id: 20149,
    codigo: "OS13910",
    slug: "mindthelook-by-vv-os13910",
    name: "MINDTHELOOK by VV SUN1246 C1",
    brand: "Mindthelook By Vv",
    category: "Óculos de Sol",
    price: 45,
    originalPrice: 90,
    discountPct: 50,
    badge: "Saldos",
    isSaldo: true,
    image: "/fotos/saldos/OS13910.jpg",
    gender: "",
    color: "",
    material: "",
    shape: "",
    style: "",
    faceShape: [],
    description:
      "[TEXTO A REVER] Artigo de saldos da Óptica 13. Descrição detalhada em preparação — contacte-nos ou visite a loja para mais informações sobre este modelo.",
  },
  {
    id: 20150,
    codigo: "OS14068",
    slug: "mindthelook-by-vv-os14068",
    name: "MINDTHELOOK by VV VV4102 C1",
    brand: "Mindthelook By Vv",
    category: "Óculos de Sol",
    price: 17,
    originalPrice: 33,
    discountPct: 50,
    badge: "Saldos",
    isSaldo: true,
    image: "/fotos/saldos/OS14068.jpg",
    gender: "",
    color: "",
    material: "",
    shape: "",
    style: "",
    faceShape: [],
    description:
      "[TEXTO A REVER] Artigo de saldos da Óptica 13. Descrição detalhada em preparação — contacte-nos ou visite a loja para mais informações sobre este modelo.",
  },
  {
    id: 20151,
    codigo: "OS14070",
    slug: "mindthelook-by-vv-os14070",
    name: "MINDTHELOOK by VV VV4111 C1",
    brand: "Mindthelook By Vv",
    category: "Óculos de Sol",
    price: 17,
    originalPrice: 33,
    discountPct: 50,
    badge: "Saldos",
    isSaldo: true,
    image: "/fotos/saldos/OS14070.jpg",
    gender: "",
    color: "",
    material: "",
    shape: "",
    style: "",
    faceShape: [],
    description:
      "[TEXTO A REVER] Artigo de saldos da Óptica 13. Descrição detalhada em preparação — contacte-nos ou visite a loja para mais informações sobre este modelo.",
  },
  {
    id: 20152,
    codigo: "OS14071",
    slug: "mindthelook-by-vv-os14071",
    name: "MINDTHELOOK by VV VV4112 C1",
    brand: "Mindthelook By Vv",
    category: "Óculos de Sol",
    price: 17,
    originalPrice: 33,
    discountPct: 50,
    badge: "Saldos",
    isSaldo: true,
    image: "/fotos/saldos/OS14071.jpg",
    gender: "",
    color: "",
    material: "",
    shape: "",
    style: "",
    faceShape: [],
    description:
      "[TEXTO A REVER] Artigo de saldos da Óptica 13. Descrição detalhada em preparação — contacte-nos ou visite a loja para mais informações sobre este modelo.",
  },
  {
    id: 20153,
    codigo: "AR17422",
    slug: "miraflex-new-baby-ar17422",
    name: "MIRAFLEX NEW BABY 3",
    brand: "Miraflex New Baby",
    category: "Aros",
    price: 31,
    originalPrice: 62,
    discountPct: 50,
    badge: "Saldos",
    isSaldo: true,
    image: "/fotos/saldos/AR17422.jpg",
    gender: "",
    color: "",
    material: "",
    shape: "",
    style: "",
    faceShape: [],
    description:
      "[TEXTO A REVER] Artigo de saldos da Óptica 13. Descrição detalhada em preparação — contacte-nos ou visite a loja para mais informações sobre este modelo.",
  },
  {
    id: 20154,
    codigo: "AR14909",
    slug: "mykita-paren-blackberry-ar14909",
    name: "MYKITA PAREN BLACKBERRY",
    brand: "Mykita Paren Blackberry",
    category: "Aros",
    price: 187,
    originalPrice: 374,
    discountPct: 50,
    badge: "Saldos",
    isSaldo: true,
    image: "/fotos/saldos/AR14909.jpg",
    gender: "",
    color: "",
    material: "",
    shape: "",
    style: "",
    faceShape: [],
    description:
      "[TEXTO A REVER] Artigo de saldos da Óptica 13. Descrição detalhada em preparação — contacte-nos ou visite a loja para mais informações sobre este modelo.",
  },
  {
    id: 20155,
    codigo: "AR13847",
    slug: "mykita-ronald-tobago-ar13847",
    name: "MYKITA RONALD TOBAGO",
    brand: "Mykita Ronald Tobago",
    category: "Aros",
    price: 187,
    originalPrice: 374,
    discountPct: 50,
    badge: "Saldos",
    isSaldo: true,
    image: "/fotos/saldos/AR13847.jpg",
    gender: "",
    color: "",
    material: "",
    shape: "",
    style: "",
    faceShape: [],
    description:
      "[TEXTO A REVER] Artigo de saldos da Óptica 13. Descrição detalhada em preparação — contacte-nos ou visite a loja para mais informações sobre este modelo.",
  },
  {
    id: 20156,
    codigo: "AR18262",
    slug: "nano-ar18262",
    name: "NANO 2152 FRAMBOESA",
    brand: "Nano",
    category: "Aros",
    price: 51,
    originalPrice: 102,
    discountPct: 50,
    badge: "Saldos",
    isSaldo: true,
    image: "/fotos/saldos/AR18262.jpg",
    gender: "",
    color: "",
    material: "",
    shape: "",
    style: "",
    faceShape: [],
    description:
      "[TEXTO A REVER] Artigo de saldos da Óptica 13. Descrição detalhada em preparação — contacte-nos ou visite a loja para mais informações sobre este modelo.",
  },
  {
    id: 20157,
    codigo: "AR19380",
    slug: "nano-arcade-ar19380",
    name: "NANO ARCADE 730346 46/17",
    brand: "Nano Arcade",
    category: "Aros",
    price: 55,
    originalPrice: 110,
    discountPct: 50,
    badge: "Saldos",
    isSaldo: true,
    image: "/fotos/saldos/AR19380.jpg",
    gender: "",
    color: "",
    material: "",
    shape: "",
    style: "",
    faceShape: [],
    description:
      "[TEXTO A REVER] Artigo de saldos da Óptica 13. Descrição detalhada em preparação — contacte-nos ou visite a loja para mais informações sobre este modelo.",
  },
  {
    id: 20158,
    codigo: "AR19381",
    slug: "nano-fanboy-ar19381",
    name: "NANO FANBOY 3170552 52/15",
    brand: "Nano Fanboy",
    category: "Aros",
    price: 55,
    originalPrice: 110,
    discountPct: 50,
    badge: "Saldos",
    isSaldo: true,
    image: "/fotos/saldos/AR19381.jpg",
    gender: "",
    color: "",
    material: "",
    shape: "",
    style: "",
    faceShape: [],
    description:
      "[TEXTO A REVER] Artigo de saldos da Óptica 13. Descrição detalhada em preparação — contacte-nos ou visite a loja para mais informações sobre este modelo.",
  },
  {
    id: 20159,
    codigo: "AR18860",
    slug: "nano-re-play-ar18860",
    name: "NANO RE-PLAY 50136HSC 44/16",
    brand: "Nano Re-Play",
    category: "Aros",
    price: 63,
    originalPrice: 125,
    discountPct: 50,
    badge: "Saldos",
    isSaldo: true,
    image: "/fotos/saldos/AR18860.jpg",
    gender: "",
    color: "",
    material: "",
    shape: "",
    style: "",
    faceShape: [],
    description:
      "[TEXTO A REVER] Artigo de saldos da Óptica 13. Descrição detalhada em preparação — contacte-nos ou visite a loja para mais informações sobre este modelo.",
  },
  {
    id: 20160,
    codigo: "AR18804",
    slug: "nano-replay-sb-ar18804",
    name: "NANO REPLAY SB 181 7902 44/16",
    brand: "Nano Replay Sb",
    category: "Aros",
    price: 51,
    originalPrice: 102,
    discountPct: 50,
    badge: "Saldos",
    isSaldo: true,
    image: "/fotos/saldos/AR18804.jpg",
    gender: "",
    color: "",
    material: "",
    shape: "",
    style: "",
    faceShape: [],
    description:
      "[TEXTO A REVER] Artigo de saldos da Óptica 13. Descrição detalhada em preparação — contacte-nos ou visite a loja para mais informações sobre este modelo.",
  },
  {
    id: 20161,
    codigo: "OS11549",
    slug: "nike-os11549",
    name: "NIKE EV0732.922",
    brand: "Nike",
    category: "Óculos de Sol",
    price: 76,
    originalPrice: 152,
    discountPct: 50,
    badge: "Saldos",
    isSaldo: true,
    image: "/fotos/saldos/OS11549.jpg",
    gender: "",
    color: "",
    material: "",
    shape: "",
    style: "",
    faceShape: [],
    description:
      "[TEXTO A REVER] Artigo de saldos da Óptica 13. Descrição detalhada em preparação — contacte-nos ou visite a loja para mais informações sobre este modelo.",
  },
  {
    id: 20162,
    codigo: "OS13409",
    slug: "no-logo-os13409",
    name: "NO LOGO 17046S 1002HE",
    brand: "No Logo",
    category: "Óculos de Sol",
    price: 65,
    originalPrice: 129,
    discountPct: 50,
    badge: "Saldos",
    isSaldo: true,
    image: "/fotos/saldos/OS13409.jpg",
    gender: "",
    color: "",
    material: "",
    shape: "",
    style: "",
    faceShape: [],
    description:
      "[TEXTO A REVER] Artigo de saldos da Óptica 13. Descrição detalhada em preparação — contacte-nos ou visite a loja para mais informações sobre este modelo.",
  },
  {
    id: 20163,
    codigo: "OS11917",
    slug: "oakley-os11917",
    name: "OAKLEY 9175.23",
    brand: "Oakley",
    category: "Óculos de Sol",
    price: 82,
    originalPrice: 164,
    discountPct: 50,
    badge: "Saldos",
    isSaldo: true,
    image: "/fotos/saldos/OS11917.jpg",
    gender: "",
    color: "",
    material: "",
    shape: "",
    style: "",
    faceShape: [],
    description:
      "[TEXTO A REVER] Artigo de saldos da Óptica 13. Descrição detalhada em preparação — contacte-nos ou visite a loja para mais informações sobre este modelo.",
  },
  {
    id: 20164,
    codigo: "AR15082",
    slug: "oliviero-contini-ar15082",
    name: "OLIVIERO CONTINI OV4112.C03",
    brand: "Oliviero Contini",
    category: "Aros",
    price: 71,
    originalPrice: 142,
    discountPct: 50,
    badge: "Saldos",
    isSaldo: true,
    image: "/fotos/saldos/AR15082.jpg",
    gender: "",
    color: "",
    material: "",
    shape: "",
    style: "",
    faceShape: [],
    description:
      "[TEXTO A REVER] Artigo de saldos da Óptica 13. Descrição detalhada em preparação — contacte-nos ou visite a loja para mais informações sobre este modelo.",
  },
  {
    id: 20165,
    codigo: "OS13862",
    slug: "one-os13862",
    name: "ONE MS4577 SP",
    brand: "One",
    category: "Óculos de Sol",
    price: 41,
    originalPrice: 82,
    discountPct: 50,
    badge: "Saldos",
    isSaldo: true,
    image: "/fotos/saldos/OS13862.jpg",
    gender: "",
    color: "",
    material: "",
    shape: "",
    style: "",
    faceShape: [],
    description:
      "[TEXTO A REVER] Artigo de saldos da Óptica 13. Descrição detalhada em preparação — contacte-nos ou visite a loja para mais informações sobre este modelo.",
  },
  {
    id: 20166,
    codigo: "AR19267",
    slug: "opposit-ar19267",
    name: "OPPOSIT TM178 V02 52/19",
    brand: "Opposit",
    category: "Aros",
    price: 131,
    originalPrice: 261,
    discountPct: 50,
    badge: "Saldos",
    isSaldo: true,
    image: "/fotos/saldos/AR19267.jpg",
    gender: "",
    color: "",
    material: "",
    shape: "",
    style: "",
    faceShape: [],
    description:
      "[TEXTO A REVER] Artigo de saldos da Óptica 13. Descrição detalhada em preparação — contacte-nos ou visite a loja para mais informações sobre este modelo.",
  },
  {
    id: 20167,
    codigo: "OS13928",
    slug: "opposit-os13928",
    name: "OPPOSIT TM177 S04 49/22",
    brand: "Opposit",
    category: "Óculos de Sol",
    price: 117,
    originalPrice: 234,
    discountPct: 50,
    badge: "Saldos",
    isSaldo: true,
    image: "/fotos/saldos/OS13928.jpg",
    gender: "",
    color: "",
    material: "",
    shape: "",
    style: "",
    faceShape: [],
    description:
      "[TEXTO A REVER] Artigo de saldos da Óptica 13. Descrição detalhada em preparação — contacte-nos ou visite a loja para mais informações sobre este modelo.",
  },
  {
    id: 20168,
    codigo: "OS13929",
    slug: "opposit-os13929",
    name: "OPPOSIT TM178 S03 52/19",
    brand: "Opposit",
    category: "Óculos de Sol",
    price: 117,
    originalPrice: 234,
    discountPct: 50,
    badge: "Saldos",
    isSaldo: true,
    image: "/fotos/saldos/OS13929.jpg",
    gender: "",
    color: "",
    material: "",
    shape: "",
    style: "",
    faceShape: [],
    description:
      "[TEXTO A REVER] Artigo de saldos da Óptica 13. Descrição detalhada em preparação — contacte-nos ou visite a loja para mais informações sobre este modelo.",
  },
  {
    id: 20169,
    codigo: "AR19969",
    slug: "orocci-ar19969",
    name: "Orocci A4016 C1",
    brand: "Orocci",
    category: "Aros",
    price: 45,
    originalPrice: 89,
    discountPct: 50,
    badge: "Saldos",
    isSaldo: true,
    image: "/fotos/saldos/AR19969.jpg",
    gender: "",
    color: "",
    material: "",
    shape: "",
    style: "",
    faceShape: [],
    description:
      "[TEXTO A REVER] Artigo de saldos da Óptica 13. Descrição detalhada em preparação — contacte-nos ou visite a loja para mais informações sobre este modelo.",
  },
  {
    id: 20170,
    codigo: "AR19975",
    slug: "orocci-ar19975",
    name: "Orocci A1049 C1",
    brand: "Orocci",
    category: "Aros",
    price: 45,
    originalPrice: 89,
    discountPct: 50,
    badge: "Saldos",
    isSaldo: true,
    image: "/fotos/saldos/AR19975.jpg",
    gender: "",
    color: "",
    material: "",
    shape: "",
    style: "",
    faceShape: [],
    description:
      "[TEXTO A REVER] Artigo de saldos da Óptica 13. Descrição detalhada em preparação — contacte-nos ou visite a loja para mais informações sobre este modelo.",
  },
  {
    id: 20171,
    codigo: "AR19988",
    slug: "orocci-ar19988",
    name: "Orocci A2063 C4",
    brand: "Orocci",
    category: "Aros",
    price: 45,
    originalPrice: 89,
    discountPct: 50,
    badge: "Saldos",
    isSaldo: true,
    image: "/fotos/saldos/AR19988.jpg",
    gender: "",
    color: "",
    material: "",
    shape: "",
    style: "",
    faceShape: [],
    description:
      "[TEXTO A REVER] Artigo de saldos da Óptica 13. Descrição detalhada em preparação — contacte-nos ou visite a loja para mais informações sobre este modelo.",
  },
  {
    id: 20172,
    codigo: "AR19992",
    slug: "orocci-ar19992",
    name: "Orocci A2065 C1",
    brand: "Orocci",
    category: "Aros",
    price: 45,
    originalPrice: 89,
    discountPct: 50,
    badge: "Saldos",
    isSaldo: true,
    image: "/fotos/saldos/AR19992.jpg",
    gender: "",
    color: "",
    material: "",
    shape: "",
    style: "",
    faceShape: [],
    description:
      "[TEXTO A REVER] Artigo de saldos da Óptica 13. Descrição detalhada em preparação — contacte-nos ou visite a loja para mais informações sobre este modelo.",
  },
  {
    id: 20173,
    codigo: "AR19993",
    slug: "orocci-ar19993",
    name: "Orocci A2065 C2",
    brand: "Orocci",
    category: "Aros",
    price: 45,
    originalPrice: 89,
    discountPct: 50,
    badge: "Saldos",
    isSaldo: true,
    image: "/fotos/saldos/AR19993.jpg",
    gender: "",
    color: "",
    material: "",
    shape: "",
    style: "",
    faceShape: [],
    description:
      "[TEXTO A REVER] Artigo de saldos da Óptica 13. Descrição detalhada em preparação — contacte-nos ou visite a loja para mais informações sobre este modelo.",
  },
  {
    id: 20174,
    codigo: "AR19994",
    slug: "orocci-ar19994",
    name: "Orocci A2065 C3",
    brand: "Orocci",
    category: "Aros",
    price: 45,
    originalPrice: 89,
    discountPct: 50,
    badge: "Saldos",
    isSaldo: true,
    image: "/fotos/saldos/AR19994.jpg",
    gender: "",
    color: "",
    material: "",
    shape: "",
    style: "",
    faceShape: [],
    description:
      "[TEXTO A REVER] Artigo de saldos da Óptica 13. Descrição detalhada em preparação — contacte-nos ou visite a loja para mais informações sobre este modelo.",
  },
  {
    id: 20175,
    codigo: "OS11403",
    slug: "paul-joe-os11403",
    name: "PAUL & JOE IOWA41.NO76",
    brand: "Paul & Joe",
    category: "Óculos de Sol",
    price: 39,
    originalPrice: 78,
    discountPct: 50,
    badge: "Saldos",
    isSaldo: true,
    image: "/fotos/saldos/OS11403.jpg",
    gender: "",
    color: "",
    material: "",
    shape: "",
    style: "",
    faceShape: [],
    description:
      "[TEXTO A REVER] Artigo de saldos da Óptica 13. Descrição detalhada em preparação — contacte-nos ou visite a loja para mais informações sobre este modelo.",
  },
  {
    id: 20176,
    codigo: "AR16641",
    slug: "prodesign-ar16641",
    name: "PRODESIGN 1747.643455-17 140",
    brand: "Prodesign",
    category: "Aros",
    price: 122,
    originalPrice: 243,
    discountPct: 50,
    badge: "Saldos",
    isSaldo: true,
    image: "/fotos/saldos/AR16641.jpg",
    gender: "",
    color: "",
    material: "",
    shape: "",
    style: "",
    faceShape: [],
    description:
      "[TEXTO A REVER] Artigo de saldos da Óptica 13. Descrição detalhada em preparação — contacte-nos ou visite a loja para mais informações sobre este modelo.",
  },
  {
    id: 20177,
    codigo: "AR12892",
    slug: "ray-ban-ar12892",
    name: "RAY-BAN 5184.2012",
    brand: "Ray-Ban",
    category: "Aros",
    price: 80,
    originalPrice: 160,
    discountPct: 50,
    badge: "Saldos",
    isSaldo: true,
    image: "/fotos/saldos/AR12892.jpg",
    gender: "",
    color: "",
    material: "",
    shape: "",
    style: "",
    faceShape: [],
    description:
      "[TEXTO A REVER] Artigo de saldos da Óptica 13. Descrição detalhada em preparação — contacte-nos ou visite a loja para mais informações sobre este modelo.",
  },
  {
    id: 20178,
    codigo: "AR17172",
    slug: "ray-ban-ar17172",
    name: "RAY-BAN 5352.5628",
    brand: "Ray-Ban",
    category: "Aros",
    price: 77,
    originalPrice: 154,
    discountPct: 50,
    badge: "Saldos",
    isSaldo: true,
    image: "/fotos/saldos/AR17172.jpg",
    gender: "",
    color: "",
    material: "",
    shape: "",
    style: "",
    faceShape: [],
    description:
      "[TEXTO A REVER] Artigo de saldos da Óptica 13. Descrição detalhada em preparação — contacte-nos ou visite a loja para mais informações sobre este modelo.",
  },
  {
    id: 20179,
    codigo: "AR18482",
    slug: "ray-ban-ar18482",
    name: "RAY-BAN 6440 3053",
    brand: "Ray-Ban",
    category: "Aros",
    price: 69,
    originalPrice: 137,
    discountPct: 50,
    badge: "Saldos",
    isSaldo: true,
    image: "/fotos/saldos/AR18482.jpg",
    gender: "",
    color: "",
    material: "",
    shape: "",
    style: "",
    faceShape: [],
    description:
      "[TEXTO A REVER] Artigo de saldos da Óptica 13. Descrição detalhada em preparação — contacte-nos ou visite a loja para mais informações sobre este modelo.",
  },
  {
    id: 20180,
    codigo: "AR18876",
    slug: "ray-ban-ar18876",
    name: "RAY-BAN 2180V 8081 47/21",
    brand: "Ray-Ban",
    category: "Aros",
    price: 70,
    originalPrice: 139,
    discountPct: 50,
    badge: "Saldos",
    isSaldo: true,
    image: "/fotos/saldos/AR18876.jpg",
    gender: "",
    color: "",
    material: "",
    shape: "",
    style: "",
    faceShape: [],
    description:
      "[TEXTO A REVER] Artigo de saldos da Óptica 13. Descrição detalhada em preparação — contacte-nos ou visite a loja para mais informações sobre este modelo.",
  },
  {
    id: 20181,
    codigo: "AR19183",
    slug: "ray-ban-ar19183",
    name: "RAY-BAN 5395 2000 51/18",
    brand: "Ray-Ban",
    category: "Aros",
    price: 75,
    originalPrice: 150,
    discountPct: 50,
    badge: "Saldos",
    isSaldo: true,
    image: "/fotos/saldos/AR19183.jpg",
    gender: "",
    color: "",
    material: "",
    shape: "",
    style: "",
    faceShape: [],
    description:
      "[TEXTO A REVER] Artigo de saldos da Óptica 13. Descrição detalhada em preparação — contacte-nos ou visite a loja para mais informações sobre este modelo.",
  },
  {
    id: 20182,
    codigo: "AR19270",
    slug: "ray-ban-ar19270",
    name: "RAY-BAN 6470 2502 52/17",
    brand: "Ray-Ban",
    category: "Aros",
    price: 60,
    originalPrice: 119,
    discountPct: 50,
    badge: "Saldos",
    isSaldo: true,
    image: "/fotos/saldos/AR19270.jpg",
    gender: "",
    color: "",
    material: "",
    shape: "",
    style: "",
    faceShape: [],
    description:
      "[TEXTO A REVER] Artigo de saldos da Óptica 13. Descrição detalhada em preparação — contacte-nos ou visite a loja para mais informações sobre este modelo.",
  },
  {
    id: 20183,
    codigo: "AR19819",
    slug: "ray-ban-ar19819",
    name: "RAY-BAN 6465 3137",
    brand: "Ray-Ban",
    category: "Aros",
    price: 75,
    originalPrice: 150,
    discountPct: 50,
    badge: "Saldos",
    isSaldo: true,
    image: "/fotos/saldos/AR19819.jpg",
    gender: "",
    color: "",
    material: "",
    shape: "",
    style: "",
    faceShape: [],
    description:
      "[TEXTO A REVER] Artigo de saldos da Óptica 13. Descrição detalhada em preparação — contacte-nos ou visite a loja para mais informações sobre este modelo.",
  },
  {
    id: 20184,
    codigo: "OS12038",
    slug: "ray-ban-os12038",
    name: "RAY-BAN RB3025.L0205",
    brand: "Ray-Ban",
    category: "Óculos de Sol",
    price: 79,
    originalPrice: 157,
    discountPct: 50,
    badge: "Saldos",
    isSaldo: true,
    image: "/fotos/saldos/OS12038.jpg",
    gender: "",
    color: "",
    material: "",
    shape: "",
    style: "",
    faceShape: [],
    description:
      "[TEXTO A REVER] Artigo de saldos da Óptica 13. Descrição detalhada em preparação — contacte-nos ou visite a loja para mais informações sobre este modelo.",
  },
  {
    id: 20185,
    codigo: "AR19565",
    slug: "rodenstock-ar19565",
    name: "RODENSTOCK 5357 B 54/17",
    brand: "Rodenstock",
    category: "Aros",
    price: 110,
    originalPrice: 220,
    discountPct: 50,
    badge: "Saldos",
    isSaldo: true,
    image: "/fotos/saldos/AR19565.jpg",
    gender: "",
    color: "",
    material: "",
    shape: "",
    style: "",
    faceShape: [],
    description:
      "[TEXTO A REVER] Artigo de saldos da Óptica 13. Descrição detalhada em preparação — contacte-nos ou visite a loja para mais informações sobre este modelo.",
  },
  {
    id: 20186,
    codigo: "AR19572",
    slug: "rodenstock-ar19572",
    name: "RODENSTOCK 7127 C 58/17",
    brand: "Rodenstock",
    category: "Aros",
    price: 201,
    originalPrice: 402,
    discountPct: 50,
    badge: "Saldos",
    isSaldo: true,
    image: "/fotos/saldos/AR19572.jpg",
    gender: "",
    color: "",
    material: "",
    shape: "",
    style: "",
    faceShape: [],
    description:
      "[TEXTO A REVER] Artigo de saldos da Óptica 13. Descrição detalhada em preparação — contacte-nos ou visite a loja para mais informações sobre este modelo.",
  },
  {
    id: 20187,
    codigo: "AR19573",
    slug: "rodenstock-ar19573",
    name: "RODENSTOCK 7127 A 56/16",
    brand: "Rodenstock",
    category: "Aros",
    price: 201,
    originalPrice: 402,
    discountPct: 50,
    badge: "Saldos",
    isSaldo: true,
    image: "/fotos/saldos/AR19573.jpg",
    gender: "",
    color: "",
    material: "",
    shape: "",
    style: "",
    faceShape: [],
    description:
      "[TEXTO A REVER] Artigo de saldos da Óptica 13. Descrição detalhada em preparação — contacte-nos ou visite a loja para mais informações sobre este modelo.",
  },
  {
    id: 20188,
    codigo: "AR19574",
    slug: "rodenstock-ar19574",
    name: "RODENSTOCK 7126 B 54/20",
    brand: "Rodenstock",
    category: "Aros",
    price: 201,
    originalPrice: 402,
    discountPct: 50,
    badge: "Saldos",
    isSaldo: true,
    image: "/fotos/saldos/AR19574.jpg",
    gender: "",
    color: "",
    material: "",
    shape: "",
    style: "",
    faceShape: [],
    description:
      "[TEXTO A REVER] Artigo de saldos da Óptica 13. Descrição detalhada em preparação — contacte-nos ou visite a loja para mais informações sobre este modelo.",
  },
  {
    id: 20189,
    codigo: "AR19575",
    slug: "rodenstock-ar19575",
    name: "RODENSTOCK 7124 B 51/18",
    brand: "Rodenstock",
    category: "Aros",
    price: 201,
    originalPrice: 402,
    discountPct: 50,
    badge: "Saldos",
    isSaldo: true,
    image: "/fotos/saldos/AR19575.jpg",
    gender: "",
    color: "",
    material: "",
    shape: "",
    style: "",
    faceShape: [],
    description:
      "[TEXTO A REVER] Artigo de saldos da Óptica 13. Descrição detalhada em preparação — contacte-nos ou visite a loja para mais informações sobre este modelo.",
  },
  {
    id: 20190,
    codigo: "AR19576",
    slug: "rodenstock-ar19576",
    name: "RODENSTOCK 5328 A 54/15",
    brand: "Rodenstock",
    category: "Aros",
    price: 138,
    originalPrice: 276,
    discountPct: 50,
    badge: "Saldos",
    isSaldo: true,
    image: "/fotos/saldos/AR19576.jpg",
    gender: "",
    color: "",
    material: "",
    shape: "",
    style: "",
    faceShape: [],
    description:
      "[TEXTO A REVER] Artigo de saldos da Óptica 13. Descrição detalhada em preparação — contacte-nos ou visite a loja para mais informações sobre este modelo.",
  },
  {
    id: 20191,
    codigo: "AR19586",
    slug: "rodenstock-ar19586",
    name: "RODENSTOCK 2638 D 52/16",
    brand: "Rodenstock",
    category: "Aros",
    price: 110,
    originalPrice: 220,
    discountPct: 50,
    badge: "Saldos",
    isSaldo: true,
    image: "/fotos/saldos/AR19586.jpg",
    gender: "",
    color: "",
    material: "",
    shape: "",
    style: "",
    faceShape: [],
    description:
      "[TEXTO A REVER] Artigo de saldos da Óptica 13. Descrição detalhada em preparação — contacte-nos ou visite a loja para mais informações sobre este modelo.",
  },
  {
    id: 20192,
    codigo: "AR19587",
    slug: "rodenstock-ar19587",
    name: "RODENSTOCK 7115 C 52/19",
    brand: "Rodenstock",
    category: "Aros",
    price: 196,
    originalPrice: 392,
    discountPct: 50,
    badge: "Saldos",
    isSaldo: true,
    image: "/fotos/saldos/AR19587.jpg",
    gender: "",
    color: "",
    material: "",
    shape: "",
    style: "",
    faceShape: [],
    description:
      "[TEXTO A REVER] Artigo de saldos da Óptica 13. Descrição detalhada em preparação — contacte-nos ou visite a loja para mais informações sobre este modelo.",
  },
  {
    id: 20193,
    codigo: "AR19595",
    slug: "rodenstock-ar19595",
    name: "RODENSTOCK 7047 D 55/15",
    brand: "Rodenstock",
    category: "Aros",
    price: 210,
    originalPrice: 420,
    discountPct: 50,
    badge: "Saldos",
    isSaldo: true,
    image: "/fotos/saldos/AR19595.jpg",
    gender: "",
    color: "",
    material: "",
    shape: "",
    style: "",
    faceShape: [],
    description:
      "[TEXTO A REVER] Artigo de saldos da Óptica 13. Descrição detalhada em preparação — contacte-nos ou visite a loja para mais informações sobre este modelo.",
  },
  {
    id: 20194,
    codigo: "AR13012",
    slug: "s-arck-ar13012",
    name: "S+ARCK PL0903.0403",
    brand: "S+Arck",
    category: "Aros",
    price: 202,
    originalPrice: 403,
    discountPct: 50,
    badge: "Saldos",
    isSaldo: true,
    image: "/fotos/saldos/AR13012.jpg",
    gender: "",
    color: "",
    material: "",
    shape: "",
    style: "",
    faceShape: [],
    description:
      "[TEXTO A REVER] Artigo de saldos da Óptica 13. Descrição detalhada em preparação — contacte-nos ou visite a loja para mais informações sobre este modelo.",
  },
  {
    id: 20195,
    codigo: "AR17902",
    slug: "stefanel-ar17902",
    name: "STEFANEL STFV06 01",
    brand: "Stefanel",
    category: "Aros",
    price: 51,
    originalPrice: 102,
    discountPct: 50,
    badge: "Saldos",
    isSaldo: true,
    image: "/fotos/saldos/AR17902.jpg",
    gender: "",
    color: "",
    material: "",
    shape: "",
    style: "",
    faceShape: [],
    description:
      "[TEXTO A REVER] Artigo de saldos da Óptica 13. Descrição detalhada em preparação — contacte-nos ou visite a loja para mais informações sobre este modelo.",
  },
  {
    id: 20196,
    codigo: "AR17904",
    slug: "stefanel-ar17904",
    name: "STEFANEL STFV06 04",
    brand: "Stefanel",
    category: "Aros",
    price: 51,
    originalPrice: 102,
    discountPct: 50,
    badge: "Saldos",
    isSaldo: true,
    image: "/fotos/saldos/AR17904.jpg",
    gender: "",
    color: "",
    material: "",
    shape: "",
    style: "",
    faceShape: [],
    description:
      "[TEXTO A REVER] Artigo de saldos da Óptica 13. Descrição detalhada em preparação — contacte-nos ou visite a loja para mais informações sobre este modelo.",
  },
  {
    id: 20197,
    codigo: "AR18330",
    slug: "stefanel-ar18330",
    name: "STEFANEL V05 C6",
    brand: "Stefanel",
    category: "Aros",
    price: 51,
    originalPrice: 102,
    discountPct: 50,
    badge: "Saldos",
    isSaldo: true,
    image: "/fotos/saldos/AR18330.jpg",
    gender: "",
    color: "",
    material: "",
    shape: "",
    style: "",
    faceShape: [],
    description:
      "[TEXTO A REVER] Artigo de saldos da Óptica 13. Descrição detalhada em preparação — contacte-nos ou visite a loja para mais informações sobre este modelo.",
  },
  {
    id: 20198,
    codigo: "AR18334",
    slug: "stefanel-ar18334",
    name: "STEFANEL V06 C3",
    brand: "Stefanel",
    category: "Aros",
    price: 51,
    originalPrice: 102,
    discountPct: 50,
    badge: "Saldos",
    isSaldo: true,
    image: "/fotos/saldos/AR18334.jpg",
    gender: "",
    color: "",
    material: "",
    shape: "",
    style: "",
    faceShape: [],
    description:
      "[TEXTO A REVER] Artigo de saldos da Óptica 13. Descrição detalhada em preparação — contacte-nos ou visite a loja para mais informações sobre este modelo.",
  },
  {
    id: 20199,
    codigo: "AR18340",
    slug: "stefanel-ar18340",
    name: "STEFANEL V104 C3",
    brand: "Stefanel",
    category: "Aros",
    price: 51,
    originalPrice: 102,
    discountPct: 50,
    badge: "Saldos",
    isSaldo: true,
    image: "/fotos/saldos/AR18340.jpg",
    gender: "",
    color: "",
    material: "",
    shape: "",
    style: "",
    faceShape: [],
    description:
      "[TEXTO A REVER] Artigo de saldos da Óptica 13. Descrição detalhada em preparação — contacte-nos ou visite a loja para mais informações sobre este modelo.",
  },
  {
    id: 20200,
    codigo: "AR18347",
    slug: "stefanel-ar18347",
    name: "STEFANEL V106 C1",
    brand: "Stefanel",
    category: "Aros",
    price: 51,
    originalPrice: 102,
    discountPct: 50,
    badge: "Saldos",
    isSaldo: true,
    image: "/fotos/saldos/AR18347.jpg",
    gender: "",
    color: "",
    material: "",
    shape: "",
    style: "",
    faceShape: [],
    description:
      "[TEXTO A REVER] Artigo de saldos da Óptica 13. Descrição detalhada em preparação — contacte-nos ou visite a loja para mais informações sobre este modelo.",
  },
  {
    id: 20201,
    codigo: "AR16280",
    slug: "titto-bluni-ar16280",
    name: "TITTO BLUNI TB130113.C05",
    brand: "Titto Bluni",
    category: "Aros",
    price: 41,
    originalPrice: 81,
    discountPct: 50,
    badge: "Saldos",
    isSaldo: true,
    image: "/fotos/saldos/AR16280.jpg",
    gender: "",
    color: "",
    material: "",
    shape: "",
    style: "",
    faceShape: [],
    description:
      "[TEXTO A REVER] Artigo de saldos da Óptica 13. Descrição detalhada em preparação — contacte-nos ou visite a loja para mais informações sobre este modelo.",
  },
  {
    id: 20202,
    codigo: "AR17906",
    slug: "titto-bluni-ar17906",
    name: "TITTO BLUNI TB2931 C2",
    brand: "Titto Bluni",
    category: "Aros",
    price: 0,
    originalPrice: 0,
    discountPct: 50,
    badge: "Saldos",
    isSaldo: true,
    image: "/fotos/saldos/AR17906.jpg",
    gender: "",
    color: "",
    material: "",
    shape: "",
    style: "",
    faceShape: [],
    description:
      "[TEXTO A REVER] Artigo de saldos da Óptica 13. Descrição detalhada em preparação — contacte-nos ou visite a loja para mais informações sobre este modelo.",
  },
  {
    id: 20203,
    codigo: "AR18648",
    slug: "tommy-hilfiger-ar18648",
    name: "TOMMY HILFIGER TH1681 J5G 49/20",
    brand: "Tommy Hilfiger",
    category: "Aros",
    price: 64,
    originalPrice: 128,
    discountPct: 50,
    badge: "Saldos",
    isSaldo: true,
    image: "/fotos/saldos/AR18648.jpg",
    gender: "",
    color: "",
    material: "",
    shape: "",
    style: "",
    faceShape: [],
    description:
      "[TEXTO A REVER] Artigo de saldos da Óptica 13. Descrição detalhada em preparação — contacte-nos ou visite a loja para mais informações sobre este modelo.",
  },
  {
    id: 20204,
    codigo: "AR18649",
    slug: "tommy-hilfiger-ar18649",
    name: "TOMMY HILFIGER TH1694 086 55/17",
    brand: "Tommy Hilfiger",
    category: "Aros",
    price: 71,
    originalPrice: 141,
    discountPct: 50,
    badge: "Saldos",
    isSaldo: true,
    image: "/fotos/saldos/AR18649.jpg",
    gender: "",
    color: "",
    material: "",
    shape: "",
    style: "",
    faceShape: [],
    description:
      "[TEXTO A REVER] Artigo de saldos da Óptica 13. Descrição detalhada em preparação — contacte-nos ou visite a loja para mais informações sobre este modelo.",
  },
  {
    id: 20205,
    codigo: "AR19753",
    slug: "tommy-hilfiger-ar19753",
    name: "TOMMY HILFIGER TH1916 KB7",
    brand: "Tommy Hilfiger",
    category: "Aros",
    price: 94,
    originalPrice: 188,
    discountPct: 50,
    badge: "Saldos",
    isSaldo: true,
    image: "/fotos/saldos/AR19753.jpg",
    gender: "",
    color: "",
    material: "",
    shape: "",
    style: "",
    faceShape: [],
    description:
      "[TEXTO A REVER] Artigo de saldos da Óptica 13. Descrição detalhada em preparação — contacte-nos ou visite a loja para mais informações sobre este modelo.",
  },
  {
    id: 20206,
    codigo: "AR19762",
    slug: "tommy-hilfiger-ar19762",
    name: "TOMMY HILFIGER TJ0058 807",
    brand: "Tommy Hilfiger",
    category: "Aros",
    price: 65,
    originalPrice: 129,
    discountPct: 50,
    badge: "Saldos",
    isSaldo: true,
    image: "/fotos/saldos/AR19762.jpg",
    gender: "",
    color: "",
    material: "",
    shape: "",
    style: "",
    faceShape: [],
    description:
      "[TEXTO A REVER] Artigo de saldos da Óptica 13. Descrição detalhada em preparação — contacte-nos ou visite a loja para mais informações sobre este modelo.",
  },
  {
    id: 20207,
    codigo: "AR19763",
    slug: "tommy-hilfiger-ar19763",
    name: "TOMMY HILFIGER TJ0079 086",
    brand: "Tommy Hilfiger",
    category: "Aros",
    price: 65,
    originalPrice: 129,
    discountPct: 50,
    badge: "Saldos",
    isSaldo: true,
    image: "/fotos/saldos/AR19763.jpg",
    gender: "",
    color: "",
    material: "",
    shape: "",
    style: "",
    faceShape: [],
    description:
      "[TEXTO A REVER] Artigo de saldos da Óptica 13. Descrição detalhada em preparação — contacte-nos ou visite a loja para mais informações sobre este modelo.",
  },
  {
    id: 20208,
    codigo: "AR19837",
    slug: "tommy-hilfiger-ar19837",
    name: "TOMMY HILFIGER TH1892 KB7 52/19",
    brand: "Tommy Hilfiger",
    category: "Aros",
    price: 80,
    originalPrice: 160,
    discountPct: 50,
    badge: "Saldos",
    isSaldo: true,
    image: "/fotos/saldos/AR19837.jpg",
    gender: "",
    color: "",
    material: "",
    shape: "",
    style: "",
    faceShape: [],
    description:
      "[TEXTO A REVER] Artigo de saldos da Óptica 13. Descrição detalhada em preparação — contacte-nos ou visite a loja para mais informações sobre este modelo.",
  },
  {
    id: 20209,
    codigo: "AR19840",
    slug: "tommy-hilfiger-ar19840",
    name: "TOMMY HILFIGER TH1945 PJP 56/17",
    brand: "Tommy Hilfiger",
    category: "Aros",
    price: 75,
    originalPrice: 149,
    discountPct: 50,
    badge: "Saldos",
    isSaldo: true,
    image: "/fotos/saldos/AR19840.jpg",
    gender: "",
    color: "",
    material: "",
    shape: "",
    style: "",
    faceShape: [],
    description:
      "[TEXTO A REVER] Artigo de saldos da Óptica 13. Descrição detalhada em preparação — contacte-nos ou visite a loja para mais informações sobre este modelo.",
  },
  {
    id: 20210,
    codigo: "AR19866",
    slug: "tommy-hilfiger-ar19866",
    name: "TOMMY HILFIGER TH1948 FLL",
    brand: "Tommy Hilfiger",
    category: "Aros",
    price: 73,
    originalPrice: 146,
    discountPct: 50,
    badge: "Saldos",
    isSaldo: true,
    image: "/fotos/saldos/AR19866.jpg",
    gender: "",
    color: "",
    material: "",
    shape: "",
    style: "",
    faceShape: [],
    description:
      "[TEXTO A REVER] Artigo de saldos da Óptica 13. Descrição detalhada em preparação — contacte-nos ou visite a loja para mais informações sobre este modelo.",
  },
  {
    id: 20211,
    codigo: "OS10497",
    slug: "transformers-sunglasses-os10497",
    name: "TRANSFORMERS SUNGLASSES TRS.004.482",
    brand: "Transformers Sunglasses",
    category: "Óculos de Sol",
    price: 39,
    originalPrice: 78,
    discountPct: 50,
    badge: "Saldos",
    isSaldo: true,
    image: "/fotos/saldos/OS10497.jpg",
    gender: "",
    color: "",
    material: "",
    shape: "",
    style: "",
    faceShape: [],
    description:
      "[TEXTO A REVER] Artigo de saldos da Óptica 13. Descrição detalhada em preparação — contacte-nos ou visite a loja para mais informações sobre este modelo.",
  },
  {
    id: 20212,
    codigo: "AR18994",
    slug: "try-ar18994",
    name: "TRY TY953 V04 57/14",
    brand: "Try",
    category: "Aros",
    price: 71,
    originalPrice: 142,
    discountPct: 50,
    badge: "Saldos",
    isSaldo: true,
    image: "/fotos/saldos/AR18994.jpg",
    gender: "",
    color: "",
    material: "",
    shape: "",
    style: "",
    faceShape: [],
    description:
      "[TEXTO A REVER] Artigo de saldos da Óptica 13. Descrição detalhada em preparação — contacte-nos ou visite a loja para mais informações sobre este modelo.",
  },
  {
    id: 20213,
    codigo: "AR18264",
    slug: "versport-ar18264",
    name: "VERSPORT 72493 VERM/CINZA",
    brand: "Versport",
    category: "Aros",
    price: 54,
    originalPrice: 107,
    discountPct: 50,
    badge: "Saldos",
    isSaldo: true,
    image: "/fotos/saldos/AR18264.jpg",
    gender: "",
    color: "",
    material: "",
    shape: "",
    style: "",
    faceShape: [],
    description:
      "[TEXTO A REVER] Artigo de saldos da Óptica 13. Descrição detalhada em preparação — contacte-nos ou visite a loja para mais informações sobre este modelo.",
  },
  {
    id: 20214,
    codigo: "AR18265",
    slug: "versport-ar18265",
    name: "VERSPORT 72492 PRATA/ROXO",
    brand: "Versport",
    category: "Aros",
    price: 54,
    originalPrice: 107,
    discountPct: 50,
    badge: "Saldos",
    isSaldo: true,
    image: "/fotos/saldos/AR18265.jpg",
    gender: "",
    color: "",
    material: "",
    shape: "",
    style: "",
    faceShape: [],
    description:
      "[TEXTO A REVER] Artigo de saldos da Óptica 13. Descrição detalhada em preparação — contacte-nos ou visite a loja para mais informações sobre este modelo.",
  },
  {
    id: 20215,
    codigo: "AR18267",
    slug: "versport-ar18267",
    name: "VERSPORT 72491 AZUL/LRANJA",
    brand: "Versport",
    category: "Aros",
    price: 54,
    originalPrice: 107,
    discountPct: 50,
    badge: "Saldos",
    isSaldo: true,
    image: "/fotos/saldos/AR18267.jpg",
    gender: "",
    color: "",
    material: "",
    shape: "",
    style: "",
    faceShape: [],
    description:
      "[TEXTO A REVER] Artigo de saldos da Óptica 13. Descrição detalhada em preparação — contacte-nos ou visite a loja para mais informações sobre este modelo.",
  },
  {
    id: 20216,
    codigo: "AR17795",
    slug: "versport-olimpo-ar17795",
    name: "VERSPORT OLIMPO 72494",
    brand: "Versport Olimpo",
    category: "Aros",
    price: 54,
    originalPrice: 107,
    discountPct: 50,
    badge: "Saldos",
    isSaldo: true,
    image: "/fotos/saldos/AR17795.jpg",
    gender: "",
    color: "",
    material: "",
    shape: "",
    style: "",
    faceShape: [],
    description:
      "[TEXTO A REVER] Artigo de saldos da Óptica 13. Descrição detalhada em preparação — contacte-nos ou visite a loja para mais informações sobre este modelo.",
  },
  {
    id: 20217,
    codigo: "AR17797",
    slug: "versport-olimpo-ar17797",
    name: "VERSPORT OLIMPO 72493",
    brand: "Versport Olimpo",
    category: "Aros",
    price: 54,
    originalPrice: 107,
    discountPct: 50,
    badge: "Saldos",
    isSaldo: true,
    image: "/fotos/saldos/AR17797.jpg",
    gender: "",
    color: "",
    material: "",
    shape: "",
    style: "",
    faceShape: [],
    description:
      "[TEXTO A REVER] Artigo de saldos da Óptica 13. Descrição detalhada em preparação — contacte-nos ou visite a loja para mais informações sobre este modelo.",
  },
  {
    id: 20218,
    codigo: "AR17799",
    slug: "versport-olimpo-ar17799",
    name: "VERSPORT OLIMPO 72491",
    brand: "Versport Olimpo",
    category: "Aros",
    price: 54,
    originalPrice: 107,
    discountPct: 50,
    badge: "Saldos",
    isSaldo: true,
    image: "/fotos/saldos/AR17799.jpg",
    gender: "",
    color: "",
    material: "",
    shape: "",
    style: "",
    faceShape: [],
    description:
      "[TEXTO A REVER] Artigo de saldos da Óptica 13. Descrição detalhada em preparação — contacte-nos ou visite a loja para mais informações sobre este modelo.",
  },
  {
    id: 20219,
    codigo: "AR16940",
    slug: "vogue-ar16940",
    name: "VOGUE 4013.99753-17 140",
    brand: "Vogue",
    category: "Aros",
    price: 58,
    originalPrice: 115,
    discountPct: 50,
    badge: "Saldos",
    isSaldo: true,
    image: "/fotos/saldos/AR16940.jpg",
    gender: "",
    color: "",
    material: "",
    shape: "",
    style: "",
    faceShape: [],
    description:
      "[TEXTO A REVER] Artigo de saldos da Óptica 13. Descrição detalhada em preparação — contacte-nos ou visite a loja para mais informações sobre este modelo.",
  },
  {
    id: 20220,
    codigo: "OS11351",
    slug: "vogue-os11351",
    name: "VOGUE 2731.196111",
    brand: "Vogue",
    category: "Óculos de Sol",
    price: 54,
    originalPrice: 107,
    discountPct: 50,
    badge: "Saldos",
    isSaldo: true,
    image: "/fotos/saldos/OS11351.jpg",
    gender: "",
    color: "",
    material: "",
    shape: "",
    style: "",
    faceShape: [],
    description:
      "[TEXTO A REVER] Artigo de saldos da Óptica 13. Descrição detalhada em preparação — contacte-nos ou visite a loja para mais informações sobre este modelo.",
  },
  {
    id: 20221,
    codigo: "AR15772",
    slug: "william-morris-ar15772",
    name: "WILLIAM MORRIS 7900.C4",
    brand: "William Morris",
    category: "Aros",
    price: 68,
    originalPrice: 135,
    discountPct: 50,
    badge: "Saldos",
    isSaldo: true,
    image: "/fotos/saldos/AR15772.jpg",
    gender: "",
    color: "",
    material: "",
    shape: "",
    style: "",
    faceShape: [],
    description:
      "[TEXTO A REVER] Artigo de saldos da Óptica 13. Descrição detalhada em preparação — contacte-nos ou visite a loja para mais informações sobre este modelo.",
  },
  {
    id: 20222,
    codigo: "AR18746",
    slug: "william-morris-ar18746",
    name: "WILLIAM MORRIS 50100 C1 51/18",
    brand: "William Morris",
    category: "Aros",
    price: 93,
    originalPrice: 186,
    discountPct: 50,
    badge: "Saldos",
    isSaldo: true,
    image: "/fotos/saldos/AR18746.jpg",
    gender: "",
    color: "",
    material: "",
    shape: "",
    style: "",
    faceShape: [],
    description:
      "[TEXTO A REVER] Artigo de saldos da Óptica 13. Descrição detalhada em preparação — contacte-nos ou visite a loja para mais informações sobre este modelo.",
  },
  {
    id: 20223,
    codigo: "AR18751",
    slug: "william-morris-ar18751",
    name: "WILLIAM MORRIS 50175 C1 52/18",
    brand: "William Morris",
    category: "Aros",
    price: 80,
    originalPrice: 160,
    discountPct: 50,
    badge: "Saldos",
    isSaldo: true,
    image: "/fotos/saldos/AR18751.jpg",
    gender: "",
    color: "",
    material: "",
    shape: "",
    style: "",
    faceShape: [],
    description:
      "[TEXTO A REVER] Artigo de saldos da Óptica 13. Descrição detalhada em preparação — contacte-nos ou visite a loja para mais informações sobre este modelo.",
  },
  {
    id: 20224,
    codigo: "AR18981",
    slug: "william-morris-ar18981",
    name: "WILLIAM MORRIS LN50174 C3 57/15",
    brand: "William Morris",
    category: "Aros",
    price: 80,
    originalPrice: 160,
    discountPct: 50,
    badge: "Saldos",
    isSaldo: true,
    image: "/fotos/saldos/AR18981.jpg",
    gender: "",
    color: "",
    material: "",
    shape: "",
    style: "",
    faceShape: [],
    description:
      "[TEXTO A REVER] Artigo de saldos da Óptica 13. Descrição detalhada em preparação — contacte-nos ou visite a loja para mais informações sobre este modelo.",
  },
  {
    id: 20225,
    codigo: "AR19998",
    slug: "william-morris-ar19998",
    name: "WILLIAM MORRIS BLLUCY C3",
    brand: "William Morris",
    category: "Aros",
    price: 116,
    originalPrice: 232,
    discountPct: 50,
    badge: "Saldos",
    isSaldo: true,
    image: "/fotos/saldos/AR19998.jpg",
    gender: "",
    color: "",
    material: "",
    shape: "",
    style: "",
    faceShape: [],
    description:
      "[TEXTO A REVER] Artigo de saldos da Óptica 13. Descrição detalhada em preparação — contacte-nos ou visite a loja para mais informações sobre este modelo.",
  },
  {
    id: 20226,
    codigo: "AR20003",
    slug: "william-morris-ar20003",
    name: "WILLIAM MORRIS LN50232 C2",
    brand: "William Morris",
    category: "Aros",
    price: 92,
    originalPrice: 183,
    discountPct: 50,
    badge: "Saldos",
    isSaldo: true,
    image: "/fotos/saldos/AR20003.jpg",
    gender: "",
    color: "",
    material: "",
    shape: "",
    style: "",
    faceShape: [],
    description:
      "[TEXTO A REVER] Artigo de saldos da Óptica 13. Descrição detalhada em preparação — contacte-nos ou visite a loja para mais informações sobre este modelo.",
  },
  {
    id: 20227,
    codigo: "AR20009",
    slug: "william-morris-ar20009",
    name: "WILLIAM MORRIS LN50286 C1",
    brand: "William Morris",
    category: "Aros",
    price: 94,
    originalPrice: 188,
    discountPct: 50,
    badge: "Saldos",
    isSaldo: true,
    image: "/fotos/saldos/AR20009.jpg",
    gender: "",
    color: "",
    material: "",
    shape: "",
    style: "",
    faceShape: [],
    description:
      "[TEXTO A REVER] Artigo de saldos da Óptica 13. Descrição detalhada em preparação — contacte-nos ou visite a loja para mais informações sobre este modelo.",
  },
  {
    id: 20228,
    codigo: "AR18975",
    slug: "william-morris-roxanne-ar18975",
    name: "WILLIAM MORRIS ROXANNE C3 53/16",
    brand: "William Morris Roxanne",
    category: "Aros",
    price: 102,
    originalPrice: 203,
    discountPct: 50,
    badge: "Saldos",
    isSaldo: true,
    image: "/fotos/saldos/AR18975.jpg",
    gender: "",
    color: "",
    material: "",
    shape: "",
    style: "",
    faceShape: [],
    description:
      "[TEXTO A REVER] Artigo de saldos da Óptica 13. Descrição detalhada em preparação — contacte-nos ou visite a loja para mais informações sobre este modelo.",
  },
  {
    id: 20229,
    codigo: "OS12876",
    slug: "optica-os12876",
    name: "ÓPTICA 13 OCULOS SOL CRIANCA",
    brand: "Óptica",
    category: "Óculos de Sol",
    price: 2,
    originalPrice: 3,
    discountPct: 50,
    badge: "Saldos",
    isSaldo: true,
    image: "/fotos/saldos/OS12876.jpg",
    gender: "",
    color: "",
    material: "",
    shape: "",
    style: "",
    faceShape: [],
    description:
      "[TEXTO A REVER] Artigo de saldos da Óptica 13. Descrição detalhada em preparação — contacte-nos ou visite a loja para mais informações sobre este modelo.",
  },
  {
    id: 20230,
    codigo: "AR15104",
    slug: "oga-ar15104",
    name: "ÖGA 7049O.MM032",
    brand: "Öga",
    category: "Aros",
    price: 112,
    originalPrice: 223,
    discountPct: 50,
    badge: "Saldos",
    isSaldo: true,
    image: "/fotos/saldos/AR15104.jpg",
    gender: "",
    color: "",
    material: "",
    shape: "",
    style: "",
    faceShape: [],
    description:
      "[TEXTO A REVER] Artigo de saldos da Óptica 13. Descrição detalhada em preparação — contacte-nos ou visite a loja para mais informações sobre este modelo.",
  },
];

export default SALDOS;
